import React from 'react';
import BaseIcon, { IconProps } from '../Base.icon';

const ComputerHelloIcon = ({ width = 270, height = 270 }: IconProps) => {
  return (
    <BaseIcon width={width} height={height} viewBox="0 0 270 270">
      <path
        d="M193.41 212.627C214.236 195.504 227.528 169.495 227.528 140.366C227.528 88.802 185.878 47 134.5 47C83.1215 47 41.4718 88.802 41.4718 140.366C41.4718 169.494 54.7636 195.504 75.5897 212.627C93.2109 212.332 113.248 212.167 134.5 212.167C155.752 212.167 175.79 212.332 193.41 212.627Z"
        fill="white"
      />
      <g opacity="0.2">
        <path
          opacity="0.2"
          d="M227.025 150.055C226.988 150.054 226.952 150.049 226.915 150.049C225.237 150.049 223.621 151.293 222.894 153.146L217.79 166.139H193.957C191.185 166.139 188.93 168.403 188.93 171.185V181.052H184.638H174.102V174.986H179.549C181.479 174.986 183.253 174.29 184.637 173.132C184.743 173.044 184.847 172.951 184.948 172.857C184.978 172.829 185.007 172.8 185.036 172.772C185.106 172.706 185.176 172.638 185.244 172.568C185.28 172.531 185.314 172.494 185.349 172.457C185.408 172.393 185.468 172.329 185.526 172.264C185.562 172.223 185.597 172.181 185.632 172.14C185.686 172.076 185.74 172.011 185.792 171.944C185.827 171.901 185.861 171.856 185.895 171.812C185.946 171.745 185.995 171.677 186.044 171.609C186.077 171.563 186.108 171.519 186.14 171.473C186.188 171.401 186.236 171.329 186.282 171.255C186.31 171.211 186.339 171.167 186.366 171.122C186.415 171.041 186.463 170.958 186.509 170.875C186.53 170.837 186.553 170.799 186.574 170.76C186.64 170.638 186.704 170.515 186.763 170.39C186.764 170.389 186.764 170.388 186.765 170.387C186.825 170.261 186.881 170.132 186.936 170.002C186.953 169.961 186.968 169.919 186.984 169.877C187.02 169.788 187.055 169.698 187.087 169.607C187.105 169.556 187.122 169.504 187.139 169.452C187.166 169.369 187.194 169.286 187.219 169.202C187.235 169.147 187.251 169.09 187.266 169.034C187.288 168.952 187.309 168.87 187.33 168.786C187.343 168.728 187.357 168.67 187.37 168.612C187.387 168.529 187.404 168.445 187.42 168.36C187.431 168.302 187.441 168.243 187.45 168.185C187.465 168.097 187.477 168.009 187.488 167.921C187.495 167.864 187.503 167.808 187.509 167.751C187.519 167.654 187.527 167.555 187.534 167.457C187.537 167.409 187.542 167.361 187.545 167.312C187.552 167.164 187.558 167.017 187.558 166.867V166.611V161.498L196.58 158.687C201.233 157.236 204.36 152.942 204.36 148V113.926C204.36 109.892 202.209 106.159 198.745 104.182L187.558 97.7962V92.0673C187.558 87.5898 183.966 83.9473 179.55 83.9473H113.321C113.118 83.9473 112.921 83.9746 112.732 84.0198H91.7148C88.4095 84.0198 85.72 86.7191 85.72 90.0364V168.899C85.72 172.216 88.4095 174.916 91.7148 174.916H101.137V181.053H87.194C86.8853 178.11 84.3991 175.809 81.3864 175.809H78.5489V171.215H79.9055C80.6957 171.215 81.3362 170.572 81.3362 169.779C81.3362 168.986 80.6957 168.343 79.9055 168.343H78.5489V163.972C78.5489 163.566 78.5285 163.166 78.4876 162.771H79.9055C80.6957 162.771 81.3362 162.129 81.3362 161.336C81.3362 160.543 80.6957 159.9 79.9055 159.9H77.8191C77.2586 158.391 76.3944 157.029 75.304 155.887L76.7771 154.408C77.336 153.847 77.336 152.938 76.7771 152.378C76.2183 151.817 75.3125 151.817 74.7536 152.378L73.0738 154.063C71.6644 153.175 70.0534 152.582 68.3259 152.369V149.837C68.3259 149.044 67.6854 148.401 66.8953 148.401C66.1051 148.401 65.4646 149.044 65.4646 149.837V152.369C64.4822 152.49 63.5372 152.734 62.6458 153.087V148.048H65.0597C65.8499 148.048 66.4904 147.405 66.4904 146.612C66.4904 145.819 65.8499 145.176 65.0597 145.176H62.2852C61.9296 143.882 61.3215 142.693 60.5177 141.664L62.1236 140.052C62.6824 139.491 62.6824 138.582 62.1236 138.022C61.5648 137.461 60.6589 137.461 60.1001 138.022L58.45 139.678C57.1818 138.768 55.6958 138.149 54.0849 137.916V135.647C54.0849 134.853 53.4444 134.211 52.6542 134.211C51.864 134.211 51.2236 134.853 51.2236 135.647V137.916C49.6126 138.149 48.1266 138.769 46.8584 139.678L45.2084 138.022C44.6495 137.461 43.7437 137.461 43.1848 138.022C42.626 138.583 42.626 139.492 43.1848 140.052L44.7907 141.664C43.9869 142.693 43.3788 143.882 43.0232 145.175H41.5994C41.6479 146.136 41.7091 147.093 41.7865 148.047H42.6626V153.227H42.3521C45.6277 177.087 57.8827 198.071 75.5889 212.629C93.2101 212.335 113.247 212.169 134.499 212.169C155.751 212.169 175.788 212.336 193.409 212.629C211.897 197.427 224.438 175.224 227.025 150.055Z"
          fill="#404851"
        />
      </g>
      <g opacity="0.3">
        <path
          opacity="0.3"
          d="M262 216.244C262 213.992 204.916 212.166 134.5 212.166C64.0841 212.166 7 213.992 7 216.244C7 217.546 26.0757 218.705 55.7749 219.452C62.1831 220.912 87.0307 222 116.706 222C141.556 222 163.02 221.237 173.107 220.131C224.649 219.608 262 218.066 262 216.244Z"
          fill="#404851"
        />
      </g>
      <path
        d="M250.198 214.781H18.8016C18.1101 214.781 17.5496 214.218 17.5496 213.524C17.5496 212.83 18.1101 212.267 18.8016 212.267H250.198C250.889 212.267 251.45 212.83 251.45 213.524C251.45 214.218 250.889 214.781 250.198 214.781Z"
        fill="#404851"
      />
      <path
        d="M48.3622 140.693C47.5721 140.693 46.9316 140.05 46.9316 139.257V135.284C46.9316 134.491 47.5721 133.849 48.3622 133.849C49.1524 133.849 49.7929 134.491 49.7929 135.284V139.257C49.7929 140.05 49.1524 140.693 48.3622 140.693Z"
        fill="#404851"
      />
      <path
        d="M54.0211 142.921C53.6554 142.921 53.2888 142.781 53.0098 142.5C52.451 141.939 52.451 141.03 53.0098 140.469L55.809 137.66C56.3678 137.099 57.2737 137.099 57.8325 137.66C58.3913 138.22 58.3913 139.129 57.8325 139.69L55.0333 142.5C54.7534 142.781 54.3868 142.921 54.0211 142.921Z"
        fill="#404851"
      />
      <path
        d="M60.7677 147.686H56.8092C56.019 147.686 55.3786 147.043 55.3786 146.25C55.3786 145.457 56.019 144.814 56.8092 144.814H60.7677C61.5579 144.814 62.1984 145.457 62.1984 146.25C62.1984 147.043 61.5571 147.686 60.7677 147.686Z"
        fill="#404851"
      />
      <path
        d="M39.9161 147.686H35.9576C35.1674 147.686 34.527 147.043 34.527 146.25C34.527 145.457 35.1674 144.814 35.9576 144.814H39.9161C40.7063 144.814 41.3468 145.457 41.3468 146.25C41.3468 147.043 40.7055 147.686 39.9161 147.686Z"
        fill="#404851"
      />
      <path
        d="M60.7677 155.737H56.8092C56.019 155.737 55.3786 155.094 55.3786 154.301C55.3786 153.508 56.019 152.866 56.8092 152.866H60.7677C61.5579 152.866 62.1984 153.508 62.1984 154.301C62.1984 155.094 61.5571 155.737 60.7677 155.737Z"
        fill="#404851"
      />
      <path
        d="M39.9161 155.737H35.9576C35.1674 155.737 34.527 155.094 34.527 154.301C34.527 153.508 35.1674 152.866 35.9576 152.866H39.9161C40.7063 152.866 41.3468 153.508 41.3468 154.301C41.3468 155.094 40.7055 155.737 39.9161 155.737Z"
        fill="#404851"
      />
      <path
        d="M60.7677 163.365H56.8092C56.019 163.365 55.3786 162.722 55.3786 161.929C55.3786 161.136 56.019 160.493 56.8092 160.493H60.7677C61.5579 160.493 62.1984 161.136 62.1984 161.929C62.1984 162.722 61.5571 163.365 60.7677 163.365Z"
        fill="#404851"
      />
      <path
        d="M39.9161 163.365H35.9576C35.1674 163.365 34.527 162.722 34.527 161.929C34.527 161.136 35.1674 160.493 35.9576 160.493H39.9161C40.7063 160.493 41.3468 161.136 41.3468 161.929C41.3468 162.722 40.7055 163.365 39.9161 163.365Z"
        fill="#404851"
      />
      <path
        d="M60.7677 171.099H56.8092C56.019 171.099 55.3786 170.456 55.3786 169.663C55.3786 168.87 56.019 168.227 56.8092 168.227H60.7677C61.5579 168.227 62.1984 168.87 62.1984 169.663C62.1984 170.456 61.5571 171.099 60.7677 171.099Z"
        fill="#404851"
      />
      <path
        d="M39.9161 171.099H35.9576C35.1674 171.099 34.527 170.456 34.527 169.663C34.527 168.87 35.1674 168.227 35.9576 168.227H39.9161C40.7063 168.227 41.3468 168.87 41.3468 169.663C41.3468 170.456 40.7055 171.099 39.9161 171.099Z"
        fill="#404851"
      />
      <path
        d="M42.7034 142.921C42.3377 142.921 41.9711 142.781 41.6921 142.5L38.8929 139.69C38.3341 139.129 38.3341 138.22 38.8929 137.66C39.4517 137.099 40.3576 137.099 40.9164 137.66L43.7156 140.469C44.2744 141.03 44.2744 141.939 43.7156 142.5C43.4357 142.781 43.07 142.921 42.7034 142.921Z"
        fill="#404851"
      />
      <path
        d="M48.3622 193.915C43.5353 193.915 39.6227 189.989 39.6227 185.144V147.476C39.6227 142.632 43.5353 138.705 48.3622 138.705C53.1892 138.705 57.1018 142.632 57.1018 147.476V185.144C57.1018 189.989 53.1892 193.915 48.3622 193.915Z"
        fill="#8BC34A"
      />
      <path
        d="M48.3622 195.081C42.9033 195.081 38.4616 190.623 38.4616 185.144V147.477C38.4616 141.998 42.9033 137.54 48.3622 137.54C53.8212 137.54 58.2628 141.998 58.2628 147.477V185.144C58.2628 190.623 53.8212 195.081 48.3622 195.081ZM48.3622 139.871C44.1834 139.871 40.7837 143.283 40.7837 147.477V185.145C40.7837 189.339 44.1834 192.751 48.3622 192.751C52.5411 192.751 55.9408 189.339 55.9408 185.145V147.477C55.9408 143.283 52.5411 139.871 48.3622 139.871Z"
        fill="#404851"
      />
      <path
        d="M48.3622 193.915C43.5353 193.915 39.6227 189.989 39.6227 185.144V147.476C39.6227 142.632 43.5353 138.705 48.3622 138.705C53.1892 138.705 57.1018 142.632 57.1018 147.476V185.144C57.1018 189.989 53.1892 193.915 48.3622 193.915Z"
        fill="#8BC34A"
      />
      <path
        d="M48.3622 195.171C42.8531 195.171 38.3706 190.673 38.3706 185.144V147.477C38.3706 141.947 42.8522 137.449 48.3622 137.449C53.8722 137.449 58.3538 141.947 58.3538 147.477V185.144C58.3538 190.673 53.8713 195.171 48.3622 195.171ZM48.3622 139.962C44.2336 139.962 40.8747 143.333 40.8747 147.477V185.144C40.8747 189.288 44.2336 192.659 48.3622 192.659C52.4909 192.659 55.8498 189.288 55.8498 185.144V147.477C55.8498 143.333 52.4909 139.962 48.3622 139.962Z"
        fill="#404851"
      />
      <g opacity="0.5">
        <path
          opacity="0.5"
          d="M43.9682 146.35C44.1579 145.388 44.2353 144.462 44.2183 143.627C45.5886 141.839 47.7345 140.68 50.151 140.68C50.7983 140.68 51.4226 140.771 52.0214 140.926C50.9386 140.314 49.6917 139.962 48.3622 139.962C46.6824 139.962 45.1352 140.527 43.884 141.468C42.0612 142.84 40.8747 145.02 40.8747 147.476V151.655V185.144C40.8747 188.639 43.2674 191.575 46.4919 192.412C44.2098 191.123 42.6626 188.672 42.6626 185.862V149.961C43.218 149.024 43.6892 147.768 43.9682 146.35Z"
          fill="white"
        />
      </g>
      <path
        d="M62.6033 155.077C61.8131 155.077 61.1726 154.435 61.1726 153.642V149.476C61.1726 148.683 61.8131 148.04 62.6033 148.04C63.3935 148.04 64.0339 148.683 64.0339 149.476V153.642C64.0339 154.435 63.3935 155.077 62.6033 155.077Z"
        fill="#404851"
      />
      <path
        d="M68.5377 157.413C68.1719 157.413 67.8053 157.273 67.5263 156.992C66.9675 156.431 66.9675 155.522 67.5263 154.961L70.4617 152.015C71.0205 151.454 71.9263 151.454 72.4852 152.015C73.044 152.576 73.044 153.485 72.4852 154.046L69.5498 156.992C69.2692 157.273 68.9034 157.413 68.5377 157.413Z"
        fill="#404851"
      />
      <path
        d="M75.6118 162.41H71.4611C70.6709 162.41 70.0304 161.767 70.0304 160.974C70.0304 160.181 70.6709 159.539 71.4611 159.539H75.6118C76.402 159.539 77.0425 160.181 77.0425 160.974C77.0425 161.767 76.402 162.41 75.6118 162.41Z"
        fill="#404851"
      />
      <path
        d="M53.7455 162.41H49.5947C48.8045 162.41 48.164 161.767 48.164 160.974C48.164 160.181 48.8045 159.539 49.5947 159.539H53.7455C54.5356 159.539 55.1761 160.181 55.1761 160.974C55.1761 161.767 54.5356 162.41 53.7455 162.41Z"
        fill="#404851"
      />
      <path
        d="M75.6118 170.854H71.4611C70.6709 170.854 70.0304 170.211 70.0304 169.418C70.0304 168.625 70.6709 167.982 71.4611 167.982H75.6118C76.402 167.982 77.0425 168.625 77.0425 169.418C77.0425 170.211 76.402 170.854 75.6118 170.854Z"
        fill="#404851"
      />
      <path
        d="M53.7455 170.854H49.5947C48.8045 170.854 48.164 170.211 48.164 169.418C48.164 168.625 48.8045 167.982 49.5947 167.982H53.7455C54.5356 167.982 55.1761 168.625 55.1761 169.418C55.1761 170.211 54.5356 170.854 53.7455 170.854Z"
        fill="#404851"
      />
      <path
        d="M56.6697 157.413C56.3031 157.413 55.9374 157.273 55.6584 156.992L52.7231 154.046C52.1642 153.485 52.1642 152.576 52.7231 152.015C53.2819 151.454 54.1877 151.454 54.7466 152.015L57.6819 154.961C58.2407 155.522 58.2407 156.431 57.6819 156.992C57.4021 157.273 57.0355 157.413 56.6697 157.413Z"
        fill="#404851"
      />
      <path
        d="M62.6033 193.916C56.8594 193.916 52.2025 189.242 52.2025 183.477V163.611C52.2025 157.846 56.8594 153.172 62.6033 153.172C68.3471 153.172 73.004 157.846 73.004 163.611V183.477C73.004 189.242 68.3471 193.916 62.6033 193.916Z"
        fill="#8BC34A"
      />
      <path
        d="M62.6033 195.171C56.1781 195.171 50.9505 189.925 50.9505 183.477V163.611C50.9505 157.162 56.1781 151.916 62.6024 151.916C69.0268 151.916 74.2552 157.162 74.2552 163.611V183.477C74.2561 189.926 69.0285 195.171 62.6033 195.171ZM62.6033 154.429C57.5586 154.429 53.4546 158.548 53.4546 163.611V183.477C53.4546 188.54 57.5586 192.659 62.6033 192.659C67.648 192.659 71.752 188.54 71.752 183.477V163.611C71.752 158.548 67.648 154.429 62.6033 154.429Z"
        fill="#404851"
      />
      <g opacity="0.5">
        <path
          opacity="0.5"
          d="M55.2425 184.195V164.329C55.2425 159.266 59.3465 155.147 64.3912 155.147C65.2503 155.147 66.0805 155.269 66.8689 155.492C65.5939 154.814 64.1429 154.429 62.6025 154.429C57.5578 154.429 53.4538 158.548 53.4538 163.611V183.477C53.4538 187.678 56.2802 191.227 60.1248 192.314C57.2244 190.772 55.2425 187.712 55.2425 184.195Z"
          fill="white"
        />
      </g>
      <path
        d="M51.4532 213.553C45.8437 213.553 40.5702 211.361 36.6031 207.379C32.6361 203.398 30.4518 198.105 30.4518 192.475V181.31C30.4518 178.77 32.5111 176.703 35.0415 176.703H77.0935C79.624 176.703 81.6832 178.77 81.6832 181.31V192.475C81.6832 198.105 79.4989 203.398 75.5319 207.379C71.5657 211.36 66.2913 213.553 60.6818 213.553H51.4532Z"
        fill="#C5D3E2"
      />
      <path
        d="M77.0935 177.96C78.9367 177.96 80.4312 179.46 80.4312 181.309V192.476C80.4312 203.423 71.5895 212.297 60.6819 212.297H51.4532C40.5464 212.297 31.7039 203.423 31.7039 192.476V181.309C31.7039 179.46 33.1983 177.96 35.0415 177.96H77.0935V177.96ZM77.0935 175.447H35.0415C31.8204 175.447 29.2007 178.078 29.2007 181.309V192.476C29.2007 195.49 29.7893 198.415 30.9503 201.17C32.0713 203.83 33.6755 206.218 35.7186 208.268C37.7616 210.318 40.1407 211.928 42.791 213.054C45.5358 214.219 48.4507 214.81 51.4532 214.81H60.6819C63.6852 214.81 66.5993 214.219 69.344 213.054C71.9944 211.928 74.3734 210.318 76.4165 208.268C78.4596 206.218 80.0637 203.83 81.1848 201.17C82.3458 198.415 82.9344 195.49 82.9344 192.476V181.309C82.9344 178.078 80.3146 175.447 77.0935 175.447Z"
        fill="#404851"
      />
      <g opacity="0.5">
        <path
          opacity="0.5"
          d="M34.208 193.553V182.386C34.208 180.536 35.7024 179.036 37.5456 179.036H79.5406C78.9308 178.376 78.0615 177.96 77.0935 177.96H35.0415C33.1983 177.96 31.7039 179.46 31.7039 181.31V192.476C31.7039 201.138 37.2419 208.497 44.9557 211.194C38.5765 207.908 34.208 201.245 34.208 193.553Z"
          fill="white"
        />
      </g>
      <g opacity="0.2">
        <path
          opacity="0.2"
          d="M51.8844 140.658C51.8844 140.658 51.1691 172.245 39.3666 173.681V176.014H52.4203V160.533L57.4276 153.401V145.504C57.4276 145.505 55.8251 140.535 51.8844 140.658Z"
          fill="#404851"
        />
      </g>
      <g opacity="0.2">
        <path
          opacity="0.2"
          d="M66.9054 154.658C66.9054 154.658 68.3361 172.963 52.2468 175.029C52.2468 175.029 51.7152 177.092 52.2468 177.092C52.7784 177.092 72.8066 177.092 72.8066 177.092V162.375C72.8066 162.375 69.9453 154.478 66.9054 154.658Z"
          fill="#404851"
        />
      </g>
      <g opacity="0.2">
        <path
          opacity="0.2"
          d="M77.0935 177.96H66.1901C66.2582 182.997 63.3288 210.652 42.5529 210.168C45.2279 211.527 48.25 212.297 51.4532 212.297H60.6818C71.5887 212.297 80.4312 203.424 80.4312 192.476V181.31C80.4312 179.46 78.9367 177.96 77.0935 177.96Z"
          fill="#404851"
        />
      </g>
      <g opacity="0.15">
        <path
          opacity="0.15"
          d="M39.0086 188.31V184.897C39.0086 183.659 40.0088 182.655 41.2422 182.655H52.1541C53.3874 182.655 54.3877 183.659 54.3877 184.897V188.31C54.3877 189.548 53.3874 190.552 52.1541 190.552H41.2422C40.0088 190.552 39.0086 189.548 39.0086 188.31Z"
          fill="white"
        />
      </g>
      <g opacity="0.2">
        <path
          opacity="0.2"
          d="M82.9344 192.476V181.31C82.9344 181.102 82.9225 180.896 82.9012 180.693H73.5917C70.2898 180.693 67.6029 183.389 67.6029 186.704V211.829C67.6029 212.465 67.8402 213.044 68.2281 213.486C76.795 210.376 82.9344 202.133 82.9344 192.476Z"
          fill="#404851"
        />
      </g>
      <path
        d="M168.558 171.183H115.865V186.067H168.558V171.183Z"
        fill="#EFEFEF"
      />
      <path
        d="M168.559 187.324H115.866C115.174 187.324 114.614 186.761 114.614 186.067V171.183C114.614 170.489 115.174 169.926 115.866 169.926H168.559C169.251 169.926 169.811 170.489 169.811 171.183V186.067C169.811 186.761 169.251 187.324 168.559 187.324ZM117.117 184.811H167.307V172.44H117.117V184.811Z"
        fill="#404851"
      />
      <g opacity="0.3">
        <path
          opacity="0.3"
          d="M168.558 171.183H115.865V186.067H168.558V171.183Z"
          fill="#404851"
        />
      </g>
      <path
        d="M150.79 171.183H98.0966V186.067H150.79V171.183Z"
        fill="#EFEFEF"
      />
      <path
        d="M150.79 187.324H98.0966C97.4051 187.324 96.8446 186.761 96.8446 186.067V171.183C96.8446 170.489 97.4051 169.926 98.0966 169.926H150.79C151.482 169.926 152.042 170.489 152.042 171.183V186.067C152.042 186.761 151.482 187.324 150.79 187.324ZM99.3478 184.811H149.538V172.44H99.3478V184.811V184.811Z"
        fill="#404851"
      />
      <g opacity="0.4">
        <path
          opacity="0.4"
          d="M101.851 172.439H99.3478V184.811H101.851V172.439Z"
          fill="white"
        />
      </g>
      <path
        d="M109.028 173.37C108.337 173.37 107.776 172.808 107.776 172.114V86.0994C107.776 85.4053 108.337 84.8428 109.028 84.8428H175.258C178.983 84.8428 182.014 87.9219 182.014 91.707V98.1667L193.833 104.913C196.906 106.667 198.815 109.983 198.815 113.566V147.64C198.815 149.776 198.155 151.815 196.906 153.534C195.655 155.257 193.929 156.499 191.915 157.126L182.013 160.212V166.507C182.013 170.292 178.982 173.371 175.257 173.371H109.028V173.37Z"
        fill="#EFEFEF"
      />
      <path
        d="M175.257 86.0994C178.297 86.0994 180.762 88.61 180.762 91.707V98.2162C180.762 98.637 180.985 99.0246 181.346 99.2303L193.216 106.005C195.902 107.538 197.564 110.429 197.564 113.566V147.64C197.564 151.449 195.122 154.813 191.546 155.927L181.57 159.035C181.091 159.184 180.763 159.635 180.763 160.147V166.506C180.763 169.603 178.298 172.114 175.258 172.114H109.029V86.0994H175.257ZM175.257 83.5862H109.028C107.645 83.5862 106.525 84.7113 106.525 86.0985V172.114C106.525 173.502 107.646 174.626 109.028 174.626H175.257C179.674 174.626 183.266 170.984 183.266 166.506V161.137L192.288 158.326C194.56 157.617 196.508 156.216 197.919 154.273C199.325 152.338 200.068 150.044 200.068 147.639V113.565C200.068 109.531 197.917 105.798 194.453 103.82L183.266 97.4351V91.7062C183.266 87.2287 179.673 83.5862 175.257 83.5862Z"
        fill="#404851"
      />
      <g opacity="0.3">
        <path
          opacity="0.3"
          d="M193.215 106.005L181.345 99.2302C180.985 99.0245 180.761 98.6369 180.761 98.216V91.7069C180.761 88.6098 178.297 86.0992 175.257 86.0992H109.027V172.115H175.257C178.297 172.115 180.761 169.604 180.761 166.507V160.147C180.761 159.637 181.089 159.185 181.569 159.036L191.544 155.928C195.121 154.814 197.563 151.45 197.563 147.64V113.567C197.564 110.429 195.901 107.538 193.215 106.005Z"
          fill="#404851"
        />
      </g>
      <g opacity="0.4">
        <g opacity="0.4">
          <path
            opacity="0.4"
            d="M178.593 120.364C180.448 120.366 182.304 120.305 184.16 120.173C186.016 120.035 187.872 119.841 189.728 119.467C187.872 119.093 186.016 118.9 184.16 118.761C182.304 118.63 180.448 118.568 178.593 118.57C176.737 118.571 174.881 118.632 173.025 118.764C171.169 118.903 169.313 119.096 167.457 119.467C169.313 119.838 171.169 120.031 173.025 120.171C174.881 120.302 176.737 120.363 178.593 120.364Z"
            fill="white"
          />
        </g>
        <g opacity="0.4">
          <path
            opacity="0.4"
            d="M178.593 125.355C176.737 125.356 174.881 125.417 173.025 125.549C171.169 125.688 169.313 125.881 167.457 126.252C169.313 126.623 171.169 126.816 173.025 126.955C174.881 127.087 176.737 127.148 178.593 127.149C180.448 127.151 182.304 127.089 184.16 126.958C186.016 126.82 187.872 126.626 189.728 126.252C187.872 125.878 186.016 125.685 184.16 125.546C182.304 125.415 180.448 125.353 178.593 125.355Z"
            fill="white"
          />
        </g>
        <g opacity="0.4">
          <path
            opacity="0.4"
            d="M178.593 132.14C176.737 132.141 174.881 132.202 173.025 132.333C171.169 132.473 169.313 132.666 167.457 133.037C169.313 133.408 171.169 133.601 173.025 133.74C174.881 133.872 176.737 133.933 178.593 133.934C180.448 133.936 182.304 133.874 184.16 133.743C186.016 133.605 187.872 133.411 189.728 133.037C187.872 132.663 186.016 132.47 184.16 132.331C182.304 132.2 180.448 132.139 178.593 132.14Z"
            fill="white"
          />
        </g>
        <g opacity="0.4">
          <path
            opacity="0.4"
            d="M178.593 138.925C176.737 138.926 174.881 138.988 173.025 139.119C171.169 139.258 169.313 139.451 167.457 139.823C169.313 140.194 171.169 140.387 173.025 140.526C174.881 140.657 176.737 140.719 178.593 140.72C180.448 140.721 182.304 140.66 184.16 140.529C186.016 140.39 187.872 140.197 189.728 139.823C187.872 139.449 186.016 139.256 184.16 139.117C182.304 138.985 180.448 138.924 178.593 138.925Z"
            fill="white"
          />
        </g>
      </g>
      <path
        d="M87.422 173.208C84.8567 173.208 82.7694 171.113 82.7694 168.538V89.6752C82.7694 87.1006 84.8567 85.0057 87.422 85.0057H153.128C155.694 85.0057 157.781 87.1006 157.781 89.6752V168.538C157.781 171.113 155.694 173.208 153.128 173.208H87.422Z"
        fill="#FCF3CF"
      />
      <path
        d="M153.128 86.1718C155.057 86.1718 156.62 87.7408 156.62 89.6761V168.539C156.62 170.474 155.057 172.042 153.128 172.042H87.422C85.4938 172.042 83.9304 170.473 83.9304 168.539V89.6752C83.9304 87.74 85.4938 86.1709 87.422 86.1709H153.128V86.1718ZM153.128 83.8405H87.422C84.2162 83.8405 81.6084 86.4578 81.6084 89.6752V168.538C81.6084 171.755 84.2162 174.373 87.422 174.373H153.128C156.334 174.373 158.942 171.755 158.942 168.538V89.6752C158.942 86.4578 156.334 83.8405 153.128 83.8405Z"
        fill="#404851"
      />
      <path
        d="M87.422 173.298C84.8065 173.298 82.6792 171.163 82.6792 168.538V89.6753C82.6792 87.0503 84.8065 84.9153 87.422 84.9153H153.128C155.744 84.9153 157.871 87.0503 157.871 89.6753V168.538C157.871 171.163 155.744 173.298 153.128 173.298H87.422Z"
        fill="#EFEFEF"
      />
      <path
        d="M153.128 86.1719C155.057 86.1719 156.62 87.7409 156.62 89.6761V168.539C156.62 170.474 155.057 172.042 153.128 172.042H87.422C85.4938 172.042 83.9304 170.473 83.9304 168.539V89.6753C83.9304 87.74 85.4938 86.171 87.422 86.171H153.128V86.1719ZM153.128 83.6587H87.422C84.1167 83.6587 81.4272 86.358 81.4272 89.6753V168.538C81.4272 171.855 84.1167 174.554 87.422 174.554H153.128C156.434 174.554 159.123 171.855 159.123 168.538V89.6753C159.123 86.358 156.434 83.6587 153.128 83.6587Z"
        fill="#404851"
      />
      <g opacity="0.4">
        <path
          opacity="0.4"
          d="M153.128 86.1719H87.422C85.4938 86.1719 83.9304 87.7409 83.9304 89.6761V168.539C83.9304 170.113 84.9656 171.445 86.3894 171.887C86.0917 171.371 85.919 170.774 85.919 170.135V118.078C86.6122 116.935 87.1251 112.774 87.1251 107.814C87.1251 102.853 86.6114 98.6925 85.919 97.5494V92.9106C85.919 90.0705 88.213 87.7682 91.0428 87.7682H155.117C155.477 87.7682 155.823 87.8229 156.149 87.9244C155.546 86.8779 154.42 86.1719 153.128 86.1719Z"
          fill="white"
        />
      </g>
      <path
        d="M145.226 147.712H95.3246C93.5112 147.712 92.0406 146.236 92.0406 144.416V97.196C92.0406 95.376 93.5112 93.9 95.3246 93.9H145.226C147.039 93.9 148.51 95.376 148.51 97.196V144.416C148.51 146.236 147.039 147.712 145.226 147.712Z"
        fill="white"
      />
      <path
        d="M145.226 148.789H95.3246C92.9218 148.789 90.968 146.827 90.968 144.416V97.1961C90.968 94.7853 92.9226 92.8236 95.3246 92.8236H145.226C147.629 92.8236 149.582 94.7853 149.582 97.1961V144.416C149.583 146.827 147.629 148.789 145.226 148.789ZM95.3246 94.9765C94.1058 94.9765 93.1132 95.9719 93.1132 97.1961V144.416C93.1132 145.639 94.1049 146.635 95.3246 146.635H145.226C146.445 146.635 147.437 145.639 147.437 144.416V97.1961C147.437 95.9728 146.445 94.9765 145.226 94.9765H95.3246V94.9765Z"
        fill="#404851"
      />
      <path
        d="M94.8925 164.886C96.4676 164.886 97.7444 163.605 97.7444 162.024C97.7444 160.443 96.4676 159.161 94.8925 159.161C93.3174 159.161 92.0405 160.443 92.0405 162.024C92.0405 163.605 93.3174 164.886 94.8925 164.886Z"
        fill="#404851"
      />
      <path
        d="M143.956 164.886H135.381C133.811 164.886 132.539 163.609 132.539 162.033V162.014C132.539 160.438 133.811 159.161 135.381 159.161H143.956C145.526 159.161 146.798 160.438 146.798 162.014V162.033C146.798 163.609 145.526 164.886 143.956 164.886Z"
        fill="#404851"
      />
      <g opacity="0.5">
        <path
          opacity="0.5"
          d="M138.055 161.895H135.04C134.672 161.895 134.374 161.595 134.374 161.226C134.374 160.857 134.673 160.558 135.04 160.558H138.055C138.424 160.558 138.721 160.858 138.721 161.226C138.722 161.595 138.424 161.895 138.055 161.895Z"
          fill="white"
        />
      </g>
      <g opacity="0.5">
        <path
          opacity="0.5"
          d="M94.1714 161.379C94.5861 160.919 94.7252 160.367 94.4822 160.146C94.2393 159.926 93.7061 160.121 93.2915 160.582C92.8769 161.043 92.7377 161.595 92.9807 161.815C93.2237 162.035 93.7568 161.84 94.1714 161.379Z"
          fill="white"
        />
      </g>
      <g opacity="0.4">
        <g opacity="0.4">
          <path
            opacity="0.4"
            d="M76.3433 167.467C75.2741 168.65 74.7961 163.572 73.5254 162.612C72.2546 161.651 69.8628 164.841 68.5921 163.88C67.3214 162.92 68.1013 162.773 68.9374 161.415C78.0317 146.646 76.0609 145.295 86.465 131.423C96.8691 117.552 100.046 119.953 110.45 106.082C120.854 92.2106 116.571 88.6551 128.196 75.7982C129.265 74.6159 129.743 79.6934 131.014 80.6538C132.285 81.6141 134.677 78.4249 135.948 79.3852C137.218 80.3456 136.438 80.4924 135.602 81.8506C126.508 96.6198 128.479 97.9711 118.075 111.842C107.67 125.713 103.449 122.745 94.0121 137.296C84.4824 151.989 87.9688 154.61 76.3433 167.467Z"
            fill="white"
          />
        </g>
      </g>
      <g opacity="0.4">
        <g opacity="0.4">
          <path
            opacity="0.4"
            d="M105.658 189.642C104.792 190.631 104.313 185.939 103.265 185.148C102.217 184.356 99.825 187.545 98.7771 186.753C97.7292 185.962 98.8443 185.761 99.5519 184.652C108.881 170.031 106.692 168.504 117.097 154.633C127.501 140.762 130.678 143.162 141.082 129.291C151.486 115.42 147.389 112.074 158.807 99.0314C159.673 98.0429 160.152 102.735 161.2 103.526C162.248 104.317 164.64 101.129 165.688 101.92C166.736 102.712 165.621 102.913 164.913 104.022C155.584 118.643 157.772 120.17 147.368 134.041C136.964 147.912 132.824 144.984 123.311 159.486C113.72 174.107 117.077 176.599 105.658 189.642Z"
            fill="white"
          />
        </g>
      </g>
      <g opacity="0.4">
        <g opacity="0.4">
          <path
            opacity="0.4"
            d="M89.0023 169.753C88.4316 170.437 87.9621 166.341 87.2519 165.804C86.5408 165.267 84.1499 168.455 83.4388 167.918C82.7277 167.381 84.3633 167.106 84.8609 166.366C94.5412 151.977 92.0278 150.178 102.432 136.307C112.836 122.436 116.013 124.837 126.417 110.965C136.821 97.0944 133.011 94.0588 144.111 80.7426C144.682 80.0579 145.151 84.1546 145.862 84.6916C146.573 85.2285 148.964 82.0401 149.675 82.5771C150.386 83.114 148.75 83.3889 148.253 84.129C138.572 98.5183 141.086 100.317 130.682 114.188C120.278 128.059 116.259 125.193 106.634 139.62C96.9474 154.135 100.102 156.436 89.0023 169.753Z"
            fill="white"
          />
        </g>
      </g>
      <g opacity="0.2">
        <path
          opacity="0.2"
          d="M95.9854 146.411V99.191C95.9854 98.0164 96.9381 97.0603 98.1085 97.0603H147.335C147.264 95.9497 146.35 95.0645 145.226 95.0645H95.3246C94.1542 95.0645 93.2015 96.0205 93.2015 97.1952V144.415C93.2015 145.59 94.1542 146.546 95.3246 146.546H95.9991C95.9965 146.501 95.9854 146.458 95.9854 146.411Z"
          fill="#404851"
        />
      </g>
      <path
        d="M140.045 119.607C139.298 120.194 138.534 120.77 137.546 120.833C136.863 120.876 137.039 121.397 136.977 121.764C136.738 123.173 136.337 124.45 134.954 125.201C133.692 125.887 132.572 125.608 131.54 124.791C131.199 124.52 131.072 124.368 130.616 124.671C129.166 125.635 128.005 125.559 126.634 124.4C126.105 123.952 125.842 123.99 125.305 124.388C123.492 125.733 121.956 125.698 120.162 124.295C119.724 123.953 119.502 124.121 119.196 124.353C117.653 125.517 115.975 125.755 114.202 125.001C113.757 124.812 113.471 124.993 113.134 125.152C112.392 125.503 111.639 125.719 110.795 125.592C109.24 125.359 108.377 124.196 108.684 122.654C108.752 122.314 108.894 121.99 108.966 121.651C109.089 121.069 109.474 120.375 108.745 119.989C108.01 119.599 107.264 119.774 106.631 120.357C105.7 121.214 105.668 122.42 105.387 123.528C105.302 123.863 105.297 124.217 105.225 124.556C105.122 125.041 104.894 125.5 104.319 125.362C103.783 125.234 103.695 124.798 103.82 124.257C104.095 123.065 104.312 121.86 104.578 120.53C103.172 121.337 101.856 122.06 100.577 122.842C99.9967 123.197 99.4643 123.232 98.8825 122.926C98.8834 122.694 98.8842 122.462 98.8851 122.23C100.188 121.501 101.494 120.776 102.787 120.028C105.042 118.724 105.675 116.712 105.87 114.343C105.958 113.275 106.446 112.337 107.42 111.775C108.722 111.025 109.796 111.654 109.855 113.143C109.907 114.454 109.465 115.561 108.589 116.509C108.076 117.064 107.556 117.612 106.898 118.311C107.568 118.314 108.049 118.297 108.529 118.321C110.006 118.397 110.963 119.728 110.546 121.155C110.35 121.826 110.157 122.484 110.176 123.195C110.189 123.674 110.35 124.001 110.815 124.178C111.507 124.442 112.121 124.225 112.657 123.834C113.109 123.504 112.66 123.148 112.551 122.816C112.154 121.606 112.296 120.455 112.939 119.37C113.482 118.452 114.351 118.136 115.317 118.409C116.277 118.681 116.872 119.404 116.912 120.452C116.954 121.556 116.516 122.47 115.714 123.222C115.529 123.396 115.196 123.568 115.331 123.864C115.44 124.106 115.766 124.145 116.044 124.168C117.131 124.26 117.983 123.776 118.713 123.043C119.225 122.53 118.804 121.932 118.723 121.411C118.3 118.671 118.676 116.047 119.65 113.476C119.867 112.902 120.25 112.488 120.705 112.132C121.553 111.469 122.618 111.705 123.149 112.643C123.817 113.822 123.825 115.109 123.577 116.362C123.17 118.416 122.416 120.364 121.184 122.073C120.616 122.86 120.838 123.268 121.595 123.662C122.724 124.248 124.308 123.884 125.03 122.884C125.263 122.562 125.122 122.31 125.065 122.02C124.523 119.224 124.799 116.495 125.72 113.817C125.745 113.744 125.761 113.667 125.79 113.597C126.361 112.234 127.3 111.5 128.229 111.686C129.184 111.878 129.885 113.026 129.914 114.436C129.967 117.124 128.933 119.461 127.642 121.733C127.401 122.156 126.579 122.594 127.302 123.19C127.996 123.76 128.805 124.157 129.737 123.619C130.44 123.213 130.682 122.552 130.801 121.795C130.982 120.643 131.503 119.68 132.472 118.996C133.652 118.164 134.977 118.06 136.122 118.932C137.086 119.665 137.907 119.533 138.716 118.849C139.17 118.465 139.568 118.432 140.05 118.682C140.047 118.989 140.047 119.298 140.045 119.607ZM135.404 121.766C135.455 120.502 135.037 119.884 134.121 119.873C133.137 119.861 132.167 121.028 132.107 122.295C132.056 123.388 132.618 124.171 133.48 124.21C134.48 124.255 135.348 123.153 135.404 121.766ZM126.357 120.921C127.634 118.801 128.699 116.647 128.551 114.114C128.528 113.717 128.494 113.294 128.013 113.221C127.629 113.162 127.351 113.432 127.219 113.771C126.322 116.078 126.016 118.462 126.357 120.921ZM120.093 121.07C121.286 119.078 122.311 117.036 122.322 114.643C122.324 114.128 122.337 113.523 121.781 113.372C121.148 113.2 120.992 113.816 120.823 114.285C120.035 116.473 119.792 118.728 120.093 121.07ZM113.7 121.479C113.664 121.901 113.674 122.5 114.109 122.629C114.559 122.762 114.859 122.203 115.087 121.829C115.43 121.265 115.651 120.644 115.253 120.007C115.1 119.761 114.831 119.664 114.553 119.809C113.902 120.15 113.701 120.742 113.7 121.479ZM106.95 116.313C107.852 115.568 108.374 114.781 108.45 113.734C108.47 113.451 108.582 113.064 108.151 112.996C107.813 112.943 107.568 113.192 107.483 113.503C107.248 114.373 106.982 115.239 106.95 116.313Z"
        fill="#404851"
      />
      <path
        d="M139.369 124.563C139.302 124.906 139.123 125.199 138.721 125.18C138.273 125.159 138.047 124.854 138.1 124.419C138.146 124.046 138.403 123.768 138.789 123.828C139.131 123.88 139.394 124.12 139.369 124.563Z"
        fill="#404851"
      />
      <path
        d="M181.774 99.0323L176.803 98.0343L181.774 97.0364C182.323 96.9263 182.857 97.284 182.967 97.8346C183.077 98.386 182.721 98.9222 182.172 99.0323C182.038 99.0596 181.9 99.057 181.774 99.0323Z"
        fill="#404851"
      />
      <path
        d="M167.457 118.39C167.92 118.29 168.385 118.212 168.848 118.141C169.312 118.069 169.776 118.009 170.24 117.951C171.168 117.839 172.096 117.755 173.024 117.686C174.88 117.555 176.736 117.493 178.592 117.493C180.448 117.492 182.304 117.552 184.16 117.684C185.087 117.752 186.015 117.836 186.943 117.948C187.407 118.006 187.871 118.067 188.335 118.14C188.798 118.211 189.263 118.29 189.726 118.39C189.263 118.491 188.798 118.568 188.335 118.64C187.871 118.712 187.407 118.773 186.943 118.831C186.015 118.944 185.087 119.027 184.16 119.096C182.304 119.227 180.448 119.289 178.592 119.287C176.736 119.285 174.88 119.225 173.024 119.093C172.096 119.025 171.168 118.94 170.24 118.829C169.776 118.771 169.312 118.711 168.848 118.638C168.385 118.567 167.921 118.49 167.457 118.39Z"
        fill="#404851"
      />
      <path
        d="M167.457 125.176C167.92 125.076 168.385 124.998 168.848 124.927C169.312 124.855 169.776 124.795 170.24 124.737C171.168 124.625 172.096 124.541 173.024 124.472C174.88 124.341 176.736 124.279 178.592 124.278C180.448 124.277 182.304 124.338 184.16 124.47C185.087 124.538 186.015 124.622 186.943 124.734C187.407 124.792 187.871 124.853 188.335 124.925C188.798 124.997 189.263 125.076 189.726 125.176C189.263 125.276 188.798 125.354 188.335 125.426C187.871 125.498 187.407 125.559 186.943 125.617C186.015 125.729 185.087 125.813 184.16 125.882C182.304 126.013 180.448 126.074 178.592 126.073C176.736 126.071 174.88 126.01 173.024 125.879C172.096 125.811 171.168 125.726 170.24 125.614C169.776 125.557 169.312 125.497 168.848 125.424C168.385 125.353 167.921 125.275 167.457 125.176Z"
        fill="#404851"
      />
      <path
        d="M167.457 131.96C167.92 131.861 168.385 131.783 168.848 131.712C169.312 131.639 169.776 131.58 170.24 131.522C171.168 131.41 172.096 131.326 173.024 131.257C174.88 131.126 176.736 131.064 178.592 131.063C180.448 131.062 182.304 131.123 184.16 131.254C185.087 131.323 186.015 131.406 186.943 131.519C187.407 131.577 187.871 131.638 188.335 131.71C188.798 131.782 189.263 131.861 189.726 131.96C189.263 132.061 188.798 132.139 188.335 132.211C187.871 132.283 187.407 132.344 186.943 132.402C186.015 132.514 185.087 132.598 184.16 132.666C182.304 132.798 180.448 132.859 178.592 132.858C176.736 132.856 174.88 132.795 173.024 132.664C172.096 132.596 171.168 132.511 170.24 132.399C169.776 132.342 169.312 132.281 168.848 132.209C168.385 132.138 167.921 132.06 167.457 131.96Z"
        fill="#404851"
      />
      <path
        d="M167.457 138.745C167.92 138.645 168.385 138.568 168.848 138.497C169.312 138.424 169.776 138.364 170.24 138.306C171.168 138.195 172.096 138.111 173.024 138.042C174.88 137.91 176.736 137.849 178.592 137.848C180.448 137.847 182.304 137.908 184.16 138.039C185.087 138.108 186.015 138.191 186.943 138.304C187.407 138.362 187.871 138.423 188.335 138.495C188.798 138.567 189.263 138.645 189.726 138.745C189.263 138.846 188.798 138.924 188.335 138.995C187.871 139.068 187.407 139.128 186.943 139.186C186.015 139.299 185.087 139.383 184.16 139.451C182.304 139.583 180.448 139.644 178.592 139.642C176.736 139.641 174.88 139.58 173.024 139.449C172.096 139.38 171.168 139.296 170.24 139.184C169.776 139.127 169.312 139.066 168.848 138.994C168.385 138.923 167.921 138.845 167.457 138.745Z"
        fill="#404851"
      />
      <path
        d="M181.837 161.062L177.2 161.296L181.313 159.137C181.811 158.875 182.426 159.068 182.686 159.568C182.946 160.068 182.754 160.685 182.257 160.946C182.124 161.016 181.977 161.054 181.837 161.062Z"
        fill="#404851"
      />
      <path
        d="M73.6836 213.084C72.9921 213.084 72.4316 212.522 72.4316 211.828V186.702C72.4316 184.081 74.5563 181.948 77.1684 181.948H156.961C157.652 181.948 158.213 182.511 158.213 183.205V211.828C158.213 212.522 157.652 213.084 156.961 213.084H73.6836Z"
        fill="#EFEFEF"
      />
      <path
        d="M156.961 183.205V211.828H73.6836V186.702C73.6836 184.77 75.2435 183.205 77.1684 183.205H156.961V183.205ZM156.961 180.693H77.1684C73.8665 180.693 71.1795 183.388 71.1795 186.703V211.829C71.1795 213.217 72.3006 214.341 73.6827 214.341H156.96C158.343 214.341 159.463 213.216 159.463 211.829V183.206C159.465 181.818 158.344 180.693 156.961 180.693Z"
        fill="#404851"
      />
      <g opacity="0.4">
        <path
          opacity="0.4"
          d="M75.8296 187.779C75.8296 185.848 77.3895 184.282 79.3144 184.282H156.961V183.205H77.1684C75.2436 183.205 73.6836 184.771 73.6836 186.703V211.829H75.8296V187.779Z"
          fill="white"
        />
      </g>
      <path
        d="M154.109 213.084C153.418 213.084 152.857 212.522 152.857 211.828V186.369C152.857 183.931 154.833 181.948 157.262 181.948H188.849C190.827 181.948 192.436 183.563 192.436 185.549V211.828C192.436 212.522 191.876 213.084 191.184 213.084H154.109Z"
        fill="#EFEFEF"
      />
      <path
        d="M188.849 183.205C190.139 183.205 191.184 184.254 191.184 185.549V211.828H154.109V186.369C154.109 184.621 155.521 183.205 157.262 183.205H188.849ZM188.849 180.693H157.262C154.143 180.693 151.605 183.24 151.605 186.37V211.829C151.605 213.217 152.726 214.341 154.108 214.341H191.184C192.567 214.341 193.687 213.216 193.687 211.829V185.549C193.688 182.871 191.518 180.693 188.849 180.693Z"
        fill="#404851"
      />
      <g opacity="0.3">
        <path
          opacity="0.3"
          d="M191.185 211.828H154.11V186.369C154.11 184.621 155.522 183.205 157.263 183.205H188.85C190.14 183.205 191.185 184.254 191.185 185.549V211.828V211.828Z"
          fill="#404851"
        />
      </g>
      <path
        d="M83.3801 189.502C84.3252 189.502 85.0914 188.733 85.0914 187.785C85.0914 186.836 84.3252 186.067 83.3801 186.067C82.435 186.067 81.6688 186.836 81.6688 187.785C81.6688 188.733 82.435 189.502 83.3801 189.502Z"
        fill="#404851"
      />
      <path
        d="M89.6547 189.502C90.5999 189.502 91.3661 188.733 91.3661 187.785C91.3661 186.836 90.5999 186.067 89.6547 186.067C88.7096 186.067 87.9434 186.836 87.9434 187.785C87.9434 188.733 88.7096 189.502 89.6547 189.502Z"
        fill="#404851"
      />
      <path
        d="M95.9294 189.502C96.8745 189.502 97.6407 188.733 97.6407 187.785C97.6407 186.836 96.8745 186.067 95.9294 186.067C94.9842 186.067 94.218 186.836 94.218 187.785C94.218 188.733 94.9842 189.502 95.9294 189.502Z"
        fill="#404851"
      />
      <path
        d="M105.021 187.838C105.833 187.742 106.645 187.659 107.457 187.59C108.269 187.517 109.081 187.458 109.893 187.4C111.517 187.288 113.141 187.204 114.764 187.135C118.012 187.003 121.26 186.942 124.508 186.941C127.755 186.939 131.003 187.001 134.251 187.132C135.875 187.201 137.498 187.284 139.122 187.397C139.934 187.455 140.746 187.516 141.558 187.588C142.37 187.658 143.182 187.741 143.994 187.838C143.182 187.936 142.37 188.018 141.558 188.088C140.746 188.161 139.934 188.222 139.122 188.28C137.498 188.392 135.875 188.476 134.251 188.544C131.003 188.676 127.755 188.737 124.508 188.736C121.26 188.735 118.012 188.673 114.764 188.542C113.141 188.473 111.517 188.389 109.893 188.277C109.081 188.22 108.269 188.159 107.457 188.087C106.645 188.018 105.833 187.935 105.021 187.838Z"
        fill="#404851"
      />
      <g opacity="0.5">
        <path
          opacity="0.5"
          d="M95.636 187.334C95.9177 187.021 96.0122 186.645 95.847 186.496C95.6817 186.346 95.3194 186.478 95.0376 186.791C94.7558 187.104 94.6614 187.48 94.8266 187.629C94.9918 187.779 95.3542 187.647 95.636 187.334Z"
          fill="white"
        />
      </g>
      <g opacity="0.5">
        <path
          opacity="0.5"
          d="M89.2732 187.334C89.555 187.02 89.6495 186.645 89.4842 186.495C89.319 186.346 88.9566 186.478 88.6748 186.791C88.393 187.104 88.2985 187.48 88.4638 187.629C88.629 187.779 88.9914 187.647 89.2732 187.334Z"
          fill="white"
        />
      </g>
      <g opacity="0.5">
        <path
          opacity="0.5"
          d="M82.9103 187.333C83.1921 187.02 83.2866 186.645 83.1213 186.495C82.9561 186.345 82.5937 186.478 82.312 186.791C82.0302 187.104 81.9357 187.479 82.101 187.629C82.2662 187.779 82.6286 187.646 82.9103 187.333Z"
          fill="white"
        />
      </g>
      <g opacity="0.2">
        <path
          opacity="0.2"
          d="M156.68 154.196C156.68 154.196 158.284 171.348 83.5357 171.348L85.3236 173.143H155.422L157.925 169.553C157.925 169.554 156.167 153.679 156.68 154.196Z"
          fill="#404851"
        />
      </g>
      <g opacity="0.2">
        <path
          opacity="0.2"
          d="M98.3781 176.553L151.31 180.501V173.681H98.3781C98.3781 173.681 97.6628 177.989 98.3781 176.553Z"
          fill="#404851"
        />
      </g>
      <g opacity="0.2">
        <path
          opacity="0.2"
          d="M149.879 181.937C149.879 181.937 148.471 182.947 147.918 185.723C147.037 190.142 144.669 194.141 141.028 196.78C132.585 202.902 113.791 210.512 72.4494 210.833L73.1648 212.627H153.277V185.706L155.423 182.116L149.879 181.937Z"
          fill="#404851"
        />
      </g>
      <g opacity="0.2">
        <path
          opacity="0.2"
          d="M180.346 172.772C182.127 171.282 183.266 169.026 183.266 166.506V166.25C181.545 167.052 180.346 168.798 180.346 170.825V172.772Z"
          fill="#404851"
        />
      </g>
      <g opacity="0.2">
        <path
          opacity="0.2"
          d="M193.688 211.828V185.549C193.688 182.871 191.518 180.693 188.85 180.693H180.346V197.772C180.346 200.759 181.273 203.531 182.85 205.82H176.221C175.53 205.82 174.969 206.382 174.969 207.076C174.969 210.58 177.378 213.522 180.619 214.341H191.184C192.567 214.341 193.688 213.216 193.688 211.828Z"
          fill="#404851"
        />
      </g>
      <path
        d="M38.9226 213.55C38.2311 213.55 37.6706 212.988 37.6706 212.294V207.594C37.6706 205.51 39.1455 203.687 41.1766 203.259L66.5949 197.898C66.68 197.88 66.7659 197.871 66.8527 197.871H144.811C145.503 197.871 146.063 198.434 146.063 199.128V212.295C146.063 212.989 145.503 213.551 144.811 213.551H38.9226V213.55Z"
        fill="#EFEFEF"
      />
      <path
        d="M144.811 199.128V212.295H66.8527H38.9226V207.595C38.9226 206.093 39.9705 204.797 41.4344 204.489L66.8527 199.128H144.811ZM144.811 196.615H66.8527C66.68 196.615 66.5074 196.633 66.3381 196.669L40.9198 202.03C39.6516 202.297 38.5025 203.001 37.6859 204.011C36.8694 205.021 36.4194 206.294 36.4194 207.595V212.295C36.4194 213.683 37.5405 214.807 38.9226 214.807H66.8527H144.811C146.194 214.807 147.315 213.682 147.315 212.295V199.128C147.315 197.74 146.194 196.615 144.811 196.615Z"
        fill="#404851"
      />
      <g opacity="0.4">
        <path
          opacity="0.4"
          d="M40.514 208.392C40.514 206.89 41.5619 205.595 43.0258 205.286L68.4441 199.925H144.811V199.127H66.8527L41.4344 204.488C39.9705 204.797 38.9226 206.093 38.9226 207.594V212.294H40.5132V208.392H40.514Z"
          fill="white"
        />
      </g>
      <path
        d="M113.074 213.371C112.481 213.371 112.002 212.889 112.002 212.295V208.772C112.002 206.529 113.513 204.574 115.678 204.018L138.761 198.085C138.848 198.063 138.937 198.052 139.028 198.052H144.732C145.324 198.052 145.804 198.534 145.804 199.128V212.295C145.804 212.89 145.323 213.371 144.732 213.371H113.074V213.371Z"
        fill="#EFEFEF"
      />
      <path
        d="M144.732 199.128V212.295H139.028H113.074V208.772C113.074 207.023 114.255 205.495 115.944 205.061L139.028 199.127H144.732V199.128ZM144.732 196.974H139.028C138.848 196.974 138.67 196.996 138.495 197.042L115.412 202.975C112.772 203.654 110.928 206.038 110.928 208.773V212.296C110.928 213.485 111.889 214.449 113.074 214.449H139.028H144.732C145.916 214.449 146.877 213.485 146.877 212.296V199.129C146.877 197.938 145.916 196.974 144.732 196.974Z"
        fill="#404851"
      />
      <g opacity="0.3">
        <path
          opacity="0.3"
          d="M139.028 199.128L115.944 205.062C114.256 205.495 113.074 207.023 113.074 208.773V212.296H139.028H144.731V199.129H139.028V199.128Z"
          fill="#404851"
        />
      </g>
      <g opacity="0.2">
        <path
          opacity="0.2"
          d="M65.5114 199.28C65.5114 199.941 66.0455 200.478 66.7047 200.478H68.9298H69.6715H70.4132C70.7296 200.478 71.0333 200.351 71.257 200.127L72.7404 198.638C72.9641 198.413 73.0899 198.109 73.0899 197.791V197.018H65.5131V199.28H65.5114Z"
          fill="#404851"
        />
      </g>
      <g opacity="0.2">
        <path
          opacity="0.2"
          d="M78.1618 198.482H77.7663V197.018H77.3768V199.28C77.3768 199.941 77.9109 200.478 78.5701 200.478H80.7952H81.5369H82.2786C82.595 200.478 82.8986 200.351 83.1223 200.127L84.6057 198.638C84.8294 198.413 84.9553 198.109 84.9553 197.791V197.018H78.1635V198.482H78.1618Z"
          fill="#404851"
        />
      </g>
      <g opacity="0.2">
        <path
          opacity="0.2"
          d="M90.0196 198.482H89.624V197.018H89.2421V199.28C89.2421 199.941 89.7763 200.478 90.4355 200.478H92.6606H93.4023H94.144C94.4604 200.478 94.764 200.351 94.9877 200.127L96.4711 198.638C96.6948 198.413 96.8207 198.109 96.8207 197.791V197.018H90.0204V198.482H90.0196Z"
          fill="#404851"
        />
      </g>
      <g opacity="0.2">
        <path
          opacity="0.2"
          d="M101.877 198.482H101.482V197.018H101.108V199.28C101.108 199.941 101.642 200.478 102.301 200.478H104.526H105.268H106.009C106.326 200.478 106.629 200.351 106.853 200.127L108.337 198.638C108.56 198.413 108.686 198.109 108.686 197.791V197.018H101.878V198.482H101.877Z"
          fill="#404851"
        />
      </g>
      <g opacity="0.2">
        <path
          opacity="0.2"
          d="M113.735 197.018V198.482H113.34V197.018H112.973V199.28C112.973 199.941 113.507 200.478 114.166 200.478H116.391H117.133H117.875C118.191 200.478 118.495 200.351 118.719 200.127L120.202 198.638C120.426 198.413 120.552 198.109 120.552 197.791V197.018H113.735Z"
          fill="#404851"
        />
      </g>
      <g opacity="0.2">
        <path
          opacity="0.2"
          d="M60.6623 200.352H58.4372H57.6955H55.4704C54.8112 200.352 54.2771 200.888 54.2771 201.55V204.527C54.2771 205.189 54.8112 205.725 55.4704 205.725H57.6955H58.4372H59.1789C59.4953 205.725 59.799 205.599 60.0227 205.374L61.506 203.885C61.7297 203.661 61.8556 203.356 61.8556 203.039V201.55C61.8548 200.888 61.3206 200.352 60.6623 200.352Z"
          fill="#404851"
        />
      </g>
      <g opacity="0.2">
        <path
          opacity="0.2"
          d="M72.5277 200.352H70.3026H69.5609H67.3358C66.6766 200.352 66.1425 200.888 66.1425 201.55V204.527C66.1425 205.189 66.6766 205.725 67.3358 205.725H69.5609H70.3026H71.0443C71.3607 205.725 71.6643 205.599 71.888 205.374L73.3714 203.885C73.5951 203.661 73.721 203.356 73.721 203.039V201.55C73.7202 200.888 73.186 200.352 72.5277 200.352Z"
          fill="#404851"
        />
      </g>
      <g opacity="0.2">
        <path
          opacity="0.2"
          d="M84.3931 200.352H82.168H81.4263H79.2012C78.542 200.352 78.0078 200.888 78.0078 201.55V204.527C78.0078 205.189 78.542 205.725 79.2012 205.725H81.4263H82.168H82.9097C83.2261 205.725 83.5297 205.599 83.7534 205.374L85.2368 203.885C85.4605 203.661 85.5864 203.356 85.5864 203.039V201.55C85.5855 200.888 85.0522 200.352 84.3931 200.352Z"
          fill="#404851"
        />
      </g>
      <g opacity="0.2">
        <path
          opacity="0.2"
          d="M96.2585 200.352H94.0335H93.2918H91.0667C90.4075 200.352 89.8733 200.888 89.8733 201.55V204.527C89.8733 205.189 90.4075 205.725 91.0667 205.725H93.2918H94.0335H94.7752C95.0916 205.725 95.3952 205.599 95.6189 205.374L97.1023 203.885C97.326 203.661 97.4519 203.356 97.4519 203.039V201.55C97.4519 200.888 96.9177 200.352 96.2585 200.352Z"
          fill="#404851"
        />
      </g>
      <g opacity="0.2">
        <path
          opacity="0.2"
          d="M108.124 200.352H105.899H105.157H102.932C102.273 200.352 101.739 200.888 101.739 201.55V204.527C101.739 205.189 102.273 205.725 102.932 205.725H105.157H105.899H106.641C106.957 205.725 107.261 205.599 107.484 205.374L108.968 203.885C109.191 203.661 109.317 203.356 109.317 203.039V201.55C109.317 200.888 108.783 200.352 108.124 200.352Z"
          fill="#404851"
        />
      </g>
      <path
        d="M56.5021 204.446C56.1074 204.446 55.7868 204.125 55.7868 203.728V200.751C55.7868 200.355 56.1074 200.033 56.5021 200.033H59.4689C59.8635 200.033 60.1842 200.354 60.1842 200.751V202.24C60.1842 202.43 60.1085 202.613 59.975 202.747L58.4916 204.236C58.3572 204.371 58.1752 204.446 57.9855 204.446H56.5021Z"
        fill="#888988"
      />
      <path
        d="M59.4689 200.752V202.24L57.9855 203.729H56.5021V200.752H59.4689ZM59.4689 199.316H56.5021C55.7119 199.316 55.0715 199.959 55.0715 200.752V203.729C55.0715 204.522 55.7119 205.165 56.5021 205.165H57.9855C58.3649 205.165 58.7289 205.014 58.9968 204.744L60.4802 203.255C60.7482 202.987 60.8995 202.621 60.8995 202.24V200.752C60.8995 199.959 60.2591 199.316 59.4689 199.316Z"
        fill="#404851"
      />
      <path
        d="M54.2779 204.446C53.8833 204.446 53.5626 204.125 53.5626 203.728V200.751C53.5626 200.355 53.8833 200.033 54.2779 200.033H57.2447C57.6394 200.033 57.96 200.354 57.96 200.751V203.728C57.96 204.124 57.6394 204.446 57.2447 204.446H54.2779Z"
        fill="#888988"
      />
      <path
        d="M57.2439 200.752V203.729H54.2771V200.752H57.2439ZM57.2439 199.316H54.2771C53.4869 199.316 52.8464 199.959 52.8464 200.752V203.729C52.8464 204.522 53.4869 205.165 54.2771 205.165H57.2439C58.034 205.165 58.6745 204.522 58.6745 203.729V200.752C58.6745 199.959 58.034 199.316 57.2439 199.316Z"
        fill="#404851"
      />
      <g opacity="0.7">
        <path
          opacity="0.7"
          d="M54.6726 201.624C54.6726 201.361 54.8844 201.149 55.1464 201.149H57.2439V200.752H54.2771V203.729H54.6726V201.624Z"
          fill="white"
        />
      </g>
      <path
        d="M68.3675 204.446C67.9728 204.446 67.6521 204.125 67.6521 203.728V200.751C67.6521 200.355 67.9728 200.033 68.3675 200.033H71.3342C71.7289 200.033 72.0496 200.354 72.0496 200.751V202.24C72.0496 202.43 71.9739 202.613 71.8403 202.747L70.357 204.236C70.2226 204.371 70.0405 204.446 69.8509 204.446H68.3675Z"
        fill="#888988"
      />
      <path
        d="M71.3343 200.752V202.24L69.8509 203.729H68.3675V200.752H71.3343ZM71.3343 199.316H68.3675C67.5773 199.316 66.9369 199.959 66.9369 200.752V203.729C66.9369 204.522 67.5773 205.165 68.3675 205.165H69.8509C70.2303 205.165 70.5943 205.014 70.8622 204.744L72.3456 203.255C72.6135 202.987 72.7649 202.621 72.7649 202.24V200.752C72.7649 199.959 72.1245 199.316 71.3343 199.316Z"
        fill="#404851"
      />
      <path
        d="M66.1433 204.446C65.7486 204.446 65.428 204.125 65.428 203.728V200.751C65.428 200.355 65.7486 200.033 66.1433 200.033H69.1101C69.5047 200.033 69.8254 200.354 69.8254 200.751V203.728C69.8254 204.124 69.5047 204.446 69.1101 204.446H66.1433Z"
        fill="#888988"
      />
      <path
        d="M69.1092 200.752V203.729H66.1424V200.752H69.1092ZM69.1092 199.316H66.1424C65.3523 199.316 64.7118 199.959 64.7118 200.752V203.729C64.7118 204.522 65.3523 205.165 66.1424 205.165H69.1092C69.8994 205.165 70.5399 204.522 70.5399 203.729V200.752C70.5399 199.959 69.8994 199.316 69.1092 199.316Z"
        fill="#404851"
      />
      <path
        d="M80.2338 204.446C79.8391 204.446 79.5185 204.125 79.5185 203.728V200.751C79.5185 200.355 79.8391 200.033 80.2338 200.033H83.2006C83.5952 200.033 83.9159 200.354 83.9159 200.751V202.24C83.9159 202.43 83.8402 202.613 83.7066 202.747L82.2233 204.236C82.0889 204.371 81.9068 204.446 81.7172 204.446H80.2338Z"
        fill="#888988"
      />
      <path
        d="M83.1997 200.752V202.24L81.7164 203.729H80.2338V200.752H83.1997ZM83.1997 199.316H80.2338C79.4436 199.316 78.8032 199.959 78.8032 200.752V203.729C78.8032 204.522 79.4436 205.165 80.2338 205.165H81.7172C82.0965 205.165 82.4606 205.014 82.7285 204.744L84.2119 203.255C84.4798 202.987 84.6312 202.621 84.6312 202.24V200.752C84.6304 199.959 83.9899 199.316 83.1997 199.316Z"
        fill="#404851"
      />
      <path
        d="M78.0087 204.446C77.6141 204.446 77.2934 204.125 77.2934 203.728V200.751C77.2934 200.355 77.6141 200.033 78.0087 200.033H80.9755C81.3702 200.033 81.6908 200.354 81.6908 200.751V203.728C81.6908 204.124 81.3702 204.446 80.9755 204.446H78.0087Z"
        fill="#888988"
      />
      <path
        d="M80.9755 200.752V203.729H78.0088V200.752H80.9755ZM80.9755 199.316H78.0088C77.2186 199.316 76.5781 199.959 76.5781 200.752V203.729C76.5781 204.522 77.2186 205.165 78.0088 205.165H80.9755C81.7657 205.165 82.4062 204.522 82.4062 203.729V200.752C82.4053 199.959 81.7649 199.316 80.9755 199.316Z"
        fill="#404851"
      />
      <path
        d="M92.0992 204.446C91.7045 204.446 91.3839 204.125 91.3839 203.728V200.751C91.3839 200.355 91.7045 200.033 92.0992 200.033H95.066C95.4606 200.033 95.7813 200.354 95.7813 200.751V202.24C95.7813 202.43 95.7056 202.613 95.5721 202.747L94.0887 204.236C93.9543 204.371 93.7723 204.446 93.5826 204.446H92.0992Z"
        fill="#888988"
      />
      <path
        d="M95.0651 200.752V202.24L93.5817 203.729H92.0983V200.752H95.0651ZM95.0651 199.316H92.0983C91.3082 199.316 90.6677 199.959 90.6677 200.752V203.729C90.6677 204.522 91.3082 205.165 92.0983 205.165H93.5817C93.9611 205.165 94.3251 205.014 94.5931 204.744L96.0765 203.255C96.3444 202.987 96.4958 202.621 96.4958 202.24V200.752C96.4958 199.959 95.8553 199.316 95.0651 199.316Z"
        fill="#404851"
      />
      <path
        d="M89.8741 204.446C89.4795 204.446 89.1588 204.125 89.1588 203.728V200.751C89.1588 200.355 89.4795 200.033 89.8741 200.033H92.8409C93.2356 200.033 93.5562 200.354 93.5562 200.751V203.728C93.5562 204.124 93.2356 204.446 92.8409 204.446H89.8741Z"
        fill="#888988"
      />
      <path
        d="M92.8409 200.752V203.729H89.8741V200.752H92.8409ZM92.8409 199.316H89.8741C89.084 199.316 88.4435 199.959 88.4435 200.752V203.729C88.4435 204.522 89.084 205.165 89.8741 205.165H92.8409C93.6311 205.165 94.2716 204.522 94.2716 203.729V200.752C94.2716 199.959 93.6311 199.316 92.8409 199.316Z"
        fill="#404851"
      />
      <path
        d="M103.965 204.446C103.57 204.446 103.249 204.125 103.249 203.728V200.751C103.249 200.355 103.57 200.033 103.965 200.033H106.931C107.326 200.033 107.647 200.354 107.647 200.751V202.24C107.647 202.43 107.571 202.613 107.437 202.747L105.954 204.236C105.82 204.371 105.638 204.446 105.448 204.446H103.965Z"
        fill="#888988"
      />
      <path
        d="M106.931 200.752V202.24L105.448 203.729H103.965V200.752H106.931ZM106.931 199.316H103.965C103.174 199.316 102.534 199.959 102.534 200.752V203.729C102.534 204.522 103.174 205.165 103.965 205.165H105.448C105.827 205.165 106.191 205.014 106.459 204.744L107.943 203.255C108.211 202.987 108.362 202.621 108.362 202.24V200.752C108.361 199.959 107.721 199.316 106.931 199.316Z"
        fill="#404851"
      />
      <path
        d="M101.74 204.446C101.345 204.446 101.024 204.125 101.024 203.728V200.751C101.024 200.355 101.345 200.033 101.74 200.033H104.706C105.101 200.033 105.422 200.354 105.422 200.751V203.728C105.422 204.124 105.101 204.446 104.706 204.446H101.74Z"
        fill="#888988"
      />
      <path
        d="M104.706 200.752V203.729H101.74V200.752H104.706ZM104.706 199.316H101.74C100.949 199.316 100.309 199.959 100.309 200.752V203.729C100.309 204.522 100.949 205.165 101.74 205.165H104.706C105.496 205.165 106.137 204.522 106.137 203.729V200.752C106.137 199.959 105.496 199.316 104.706 199.316Z"
        fill="#404851"
      />
      <path
        d="M68.1337 199.2C67.739 199.2 67.4184 198.879 67.4184 198.482V195.504C67.4184 195.108 67.739 194.786 68.1337 194.786H71.1005C71.4951 194.786 71.8158 195.107 71.8158 195.504V196.993C71.8158 197.183 71.7401 197.366 71.6066 197.501L70.1232 198.99C69.9888 199.125 69.8068 199.2 69.6171 199.2H68.1337Z"
        fill="#888988"
      />
      <path
        d="M71.0996 195.505V196.994L69.6162 198.483H68.1328V195.505H71.0996ZM71.0996 194.069H68.1328C67.3427 194.069 66.7022 194.712 66.7022 195.505V198.483C66.7022 199.276 67.3427 199.918 68.1328 199.918H69.6162C69.9956 199.918 70.3596 199.767 70.6276 199.498L72.1109 198.009C72.3789 197.74 72.5303 197.375 72.5303 196.994V195.505C72.5303 194.712 71.8898 194.069 71.0996 194.069Z"
        fill="#404851"
      />
      <path
        d="M65.9085 199.2C65.5139 199.2 65.1932 198.879 65.1932 198.482V195.504C65.1932 195.108 65.5139 194.786 65.9085 194.786H68.8753C69.27 194.786 69.5907 195.107 69.5907 195.504V198.482C69.5907 198.878 69.27 199.2 68.8753 199.2H65.9085Z"
        fill="#888988"
      />
      <path
        d="M68.8754 195.505V198.483H65.9086V195.505H68.8754ZM68.8754 194.069H65.9086C65.1184 194.069 64.4779 194.712 64.4779 195.505V198.483C64.4779 199.276 65.1184 199.918 65.9086 199.918H68.8754C69.6655 199.918 70.306 199.276 70.306 198.483V195.505C70.306 194.712 69.6655 194.069 68.8754 194.069Z"
        fill="#404851"
      />
      <g opacity="0.7">
        <path
          opacity="0.7"
          d="M66.3041 196.385C66.3041 196.118 66.5201 195.901 66.7864 195.901H68.8754V195.504H65.9086V198.482H66.3041V196.385Z"
          fill="white"
        />
      </g>
      <path
        d="M79.9991 199.2C79.6044 199.2 79.2838 198.879 79.2838 198.482V195.504C79.2838 195.108 79.6044 194.786 79.9991 194.786H82.9659C83.3605 194.786 83.6812 195.107 83.6812 195.504V196.993C83.6812 197.183 83.6055 197.366 83.4719 197.501L81.9886 198.99C81.8542 199.125 81.6722 199.2 81.4825 199.2H79.9991Z"
        fill="#888988"
      />
      <path
        d="M82.9658 195.505V196.994L81.4824 198.483H79.999V195.505H82.9658ZM82.9658 194.069H79.999C79.2089 194.069 78.5684 194.712 78.5684 195.505V198.483C78.5684 199.276 79.2089 199.918 79.999 199.918H81.4824C81.8618 199.918 82.2258 199.767 82.4938 199.498L83.9771 198.009C84.2451 197.74 84.3965 197.375 84.3965 196.994V195.505C84.3965 194.712 83.756 194.069 82.9658 194.069Z"
        fill="#404851"
      />
      <path
        d="M77.7739 199.2C77.3793 199.2 77.0586 198.879 77.0586 198.482V195.504C77.0586 195.108 77.3793 194.786 77.7739 194.786H80.7407C81.1354 194.786 81.456 195.107 81.456 195.504V198.482C81.456 198.878 81.1354 199.2 80.7407 199.2H77.7739Z"
        fill="#888988"
      />
      <path
        d="M80.7408 195.505V198.483H77.774V195.505H80.7408ZM80.7408 194.069H77.774C76.9838 194.069 76.3433 194.712 76.3433 195.505V198.483C76.3433 199.276 76.9838 199.918 77.774 199.918H80.7408C81.5309 199.918 82.1714 199.276 82.1714 198.483V195.505C82.1714 194.712 81.5309 194.069 80.7408 194.069Z"
        fill="#404851"
      />
      <g opacity="0.7">
        <path
          opacity="0.7"
          d="M78.1618 196.385C78.1618 196.118 78.3779 195.901 78.6441 195.901H80.7331V195.504H77.7663V198.482H78.1618V196.385Z"
          fill="white"
        />
      </g>
      <path
        d="M91.8645 199.2C91.4699 199.2 91.1492 198.879 91.1492 198.482V195.504C91.1492 195.108 91.4699 194.786 91.8645 194.786H94.8313C95.226 194.786 95.5466 195.107 95.5466 195.504V196.993C95.5466 197.183 95.4709 197.366 95.3374 197.501L93.854 198.99C93.7196 199.125 93.5376 199.2 93.3479 199.2H91.8645Z"
        fill="#888988"
      />
      <path
        d="M94.8313 195.505V196.994L93.3479 198.483H91.8645V195.505H94.8313ZM94.8313 194.069H91.8645C91.0743 194.069 90.4339 194.712 90.4339 195.505V198.483C90.4339 199.276 91.0743 199.918 91.8645 199.918H93.3479C93.7272 199.918 94.0913 199.767 94.3592 199.498L95.8426 198.009C96.1105 197.74 96.2619 197.375 96.2619 196.994V195.505C96.2619 194.712 95.6215 194.069 94.8313 194.069Z"
        fill="#404851"
      />
      <path
        d="M89.6403 199.2C89.2456 199.2 88.9249 198.879 88.9249 198.482V195.504C88.9249 195.108 89.2456 194.786 89.6403 194.786H92.607C93.0017 194.786 93.3224 195.107 93.3224 195.504V198.482C93.3224 198.878 93.0017 199.2 92.607 199.2H89.6403Z"
        fill="#888988"
      />
      <path
        d="M92.6062 195.505V198.483H89.6394V195.505H92.6062ZM92.6062 194.069H89.6394C88.8492 194.069 88.2088 194.712 88.2088 195.505V198.483C88.2088 199.276 88.8492 199.918 89.6394 199.918H92.6062C93.3964 199.918 94.0369 199.276 94.0369 198.483V195.505C94.0369 194.712 93.3964 194.069 92.6062 194.069Z"
        fill="#404851"
      />
      <path
        d="M103.73 199.2C103.335 199.2 103.015 198.879 103.015 198.482V195.504C103.015 195.108 103.335 194.786 103.73 194.786H106.697C107.091 194.786 107.412 195.107 107.412 195.504V196.993C107.412 197.183 107.336 197.366 107.203 197.501L105.719 198.99C105.585 199.125 105.403 199.2 105.213 199.2H103.73Z"
        fill="#888988"
      />
      <path
        d="M106.697 195.505V196.994L105.213 198.483H103.73V195.505H106.697ZM106.697 194.069H103.73C102.94 194.069 102.299 194.712 102.299 195.505V198.483C102.299 199.276 102.94 199.918 103.73 199.918H105.213C105.593 199.918 105.957 199.767 106.225 199.498L107.708 198.009C107.976 197.74 108.127 197.375 108.127 196.994V195.505C108.127 194.712 107.487 194.069 106.697 194.069Z"
        fill="#404851"
      />
      <path
        d="M101.506 199.2C101.111 199.2 100.79 198.879 100.79 198.482V195.504C100.79 195.108 101.111 194.786 101.506 194.786H104.472C104.867 194.786 105.188 195.107 105.188 195.504V198.482C105.188 198.878 104.867 199.2 104.472 199.2H101.506Z"
        fill="#888988"
      />
      <path
        d="M104.472 195.505V198.483H101.505V195.505H104.472ZM104.472 194.069H101.505C100.715 194.069 100.074 194.712 100.074 195.505V198.483C100.074 199.276 100.715 199.918 101.505 199.918H104.472C105.262 199.918 105.902 199.276 105.902 198.483V195.505C105.902 194.712 105.262 194.069 104.472 194.069Z"
        fill="#404851"
      />
      <path
        d="M115.596 199.2C115.201 199.2 114.881 198.879 114.881 198.482V195.504C114.881 195.108 115.201 194.786 115.596 194.786H118.563C118.958 194.786 119.278 195.107 119.278 195.504V196.993C119.278 197.183 119.203 197.366 119.069 197.501L117.586 198.99C117.451 199.125 117.269 199.2 117.08 199.2H115.596Z"
        fill="#888988"
      />
      <path
        d="M118.562 195.505V196.994L117.079 198.483H115.595V195.505H118.562ZM118.562 194.069H115.595C114.805 194.069 114.165 194.712 114.165 195.505V198.483C114.165 199.276 114.805 199.918 115.595 199.918H117.079C117.458 199.918 117.822 199.767 118.09 199.498L119.573 198.009C119.841 197.74 119.993 197.375 119.993 196.994V195.505C119.993 194.712 119.352 194.069 118.562 194.069Z"
        fill="#404851"
      />
      <path
        d="M113.371 199.2C112.976 199.2 112.656 198.879 112.656 198.482V195.504C112.656 195.108 112.976 194.786 113.371 194.786H116.338C116.733 194.786 117.053 195.107 117.053 195.504V198.482C117.053 198.878 116.733 199.2 116.338 199.2H113.371Z"
        fill="#888988"
      />
      <path
        d="M116.338 195.505V198.483H113.371V195.505H116.338ZM116.338 194.069H113.371C112.581 194.069 111.94 194.712 111.94 195.505V198.483C111.94 199.276 112.581 199.918 113.371 199.918H116.338C117.128 199.918 117.768 199.276 117.768 198.483V195.505C117.768 194.712 117.127 194.069 116.338 194.069Z"
        fill="#404851"
      />
      <g opacity="0.7">
        <path
          opacity="0.7"
          d="M90.0196 196.385C90.0196 196.118 90.2357 195.901 90.5019 195.901H92.5909V195.504H89.6241V198.482H90.0196V196.385Z"
          fill="white"
        />
      </g>
      <g opacity="0.7">
        <path
          opacity="0.7"
          d="M101.877 196.385C101.877 196.118 102.093 195.901 102.36 195.901H104.449V195.504H101.482V198.482H101.877V196.385Z"
          fill="white"
        />
      </g>
      <g opacity="0.7">
        <path
          opacity="0.7"
          d="M113.735 196.385C113.735 196.118 113.951 195.901 114.217 195.901H116.306V195.504H113.34V198.482H113.735V196.385Z"
          fill="white"
        />
      </g>
      <g opacity="0.7">
        <path
          opacity="0.7"
          d="M66.5303 201.624C66.5303 201.361 66.743 201.149 67.0041 201.149H69.1016V200.752H66.1348V203.729H66.5303V201.624Z"
          fill="white"
        />
      </g>
      <g opacity="0.7">
        <path
          opacity="0.7"
          d="M78.3881 201.624C78.3881 201.361 78.5999 201.149 78.8618 201.149H80.9593V200.752H77.9926V203.729H78.3881V201.624Z"
          fill="white"
        />
      </g>
      <g opacity="0.7">
        <path
          opacity="0.7"
          d="M90.2458 201.624C90.2458 201.361 90.4576 201.149 90.7196 201.149H92.8171V200.752H89.8503V203.729H90.2458V201.624Z"
          fill="white"
        />
      </g>
      <g opacity="0.7">
        <path
          opacity="0.7"
          d="M102.104 201.624C102.104 201.361 102.315 201.149 102.577 201.149H104.675V200.752H101.708V203.729H102.104V201.624Z"
          fill="white"
        />
      </g>
      <path
        d="M78.1619 197.018H77.7663V198.482H78.1619V197.018Z"
        fill="#404851"
      />
      <g opacity="0.7">
        <path
          opacity="0.7"
          d="M78.1619 197.018H77.7663V198.482H78.1619V197.018Z"
          fill="white"
        />
      </g>
      <path
        d="M78.1618 196.385C78.1618 196.118 78.3779 195.901 78.6441 195.901H80.7331V195.504H77.7663V197.017H78.1618V196.385Z"
        fill="#404851"
      />
      <g opacity="0.7">
        <path
          opacity="0.7"
          d="M78.1618 196.385C78.1618 196.118 78.3779 195.901 78.6441 195.901H80.7331V195.504H77.7663V197.017H78.1618V196.385Z"
          fill="white"
        />
      </g>
      <path
        d="M90.0196 197.018H89.6241V198.482H90.0196V197.018Z"
        fill="#404851"
      />
      <g opacity="0.7">
        <path
          opacity="0.7"
          d="M90.0196 197.018H89.6241V198.482H90.0196V197.018Z"
          fill="white"
        />
      </g>
      <path
        d="M90.0196 196.385C90.0196 196.118 90.2356 195.901 90.5019 195.901H92.5909V195.504H89.6241V197.017H90.0196V196.385Z"
        fill="#404851"
      />
      <g opacity="0.7">
        <path
          opacity="0.7"
          d="M90.0196 196.385C90.0196 196.118 90.2356 195.901 90.5019 195.901H92.5909V195.504H89.6241V197.017H90.0196V196.385Z"
          fill="white"
        />
      </g>
      <path
        d="M101.877 196.385C101.877 196.118 102.093 195.901 102.36 195.901H104.449V195.504H101.482V197.017H101.877V196.385Z"
        fill="#404851"
      />
      <g opacity="0.7">
        <path
          opacity="0.7"
          d="M101.877 196.385C101.877 196.118 102.093 195.901 102.36 195.901H104.449V195.504H101.482V197.017H101.877V196.385Z"
          fill="white"
        />
      </g>
      <path
        d="M101.877 197.018H101.482V198.482H101.877V197.018Z"
        fill="#404851"
      />
      <g opacity="0.7">
        <path
          opacity="0.7"
          d="M101.877 197.018H101.482V198.482H101.877V197.018Z"
          fill="white"
        />
      </g>
      <path
        d="M114.217 195.901H116.306V195.504H113.34V197.017H113.735V196.384C113.735 196.118 113.951 195.901 114.217 195.901Z"
        fill="#404851"
      />
      <g opacity="0.7">
        <path
          opacity="0.7"
          d="M114.217 195.901H116.306V195.504H113.34V197.017H113.735V196.384C113.735 196.118 113.951 195.901 114.217 195.901Z"
          fill="white"
        />
      </g>
      <path
        d="M113.735 197.018H113.34V198.482H113.735V197.018Z"
        fill="#404851"
      />
      <g opacity="0.7">
        <path
          opacity="0.7"
          d="M113.735 197.018H113.34V198.482H113.735V197.018Z"
          fill="white"
        />
      </g>
      <g opacity="0.2">
        <path
          opacity="0.2"
          d="M111.968 205.628C111.968 205.628 75.4885 211.371 38.2941 210.653V213.346C38.2941 213.346 112.505 212.628 112.505 213.346C112.505 214.063 111.968 205.628 111.968 205.628Z"
          fill="#404851"
        />
      </g>
      <path
        d="M150.147 213.55C147.477 213.55 145.306 211.37 145.306 208.691V208.658C145.306 204.27 148.862 200.701 153.234 200.701H170.093C174.465 200.701 178.021 204.27 178.021 208.658V208.691C178.021 211.371 175.849 213.55 173.18 213.55H150.147Z"
        fill="#EFEFEF"
      />
      <path
        d="M170.092 201.958C173.779 201.958 176.768 204.958 176.768 208.658V208.692C176.768 210.681 175.161 212.295 173.178 212.295H150.146C148.164 212.295 146.556 210.681 146.556 208.692V208.658C146.556 204.958 149.545 201.958 153.232 201.958H170.092ZM170.092 199.445H153.233C150.781 199.445 148.476 200.403 146.742 202.143C145.009 203.883 144.054 206.197 144.054 208.657V208.691C144.054 212.063 146.787 214.806 150.147 214.806H173.179C176.538 214.806 179.272 212.063 179.272 208.691V208.657C179.272 206.196 178.317 203.883 176.584 202.143C174.849 200.403 172.544 199.445 170.092 199.445Z"
        fill="#404851"
      />
      <g opacity="0.4">
        <path
          opacity="0.4"
          d="M147.988 209.409V209.376C147.988 205.675 150.976 202.676 154.664 202.676H171.523C172.32 202.676 173.08 202.823 173.789 203.08C172.73 202.373 171.46 201.958 170.092 201.958H153.233C149.546 201.958 146.557 204.958 146.557 208.658V208.691C146.557 210.385 147.722 211.801 149.291 212.187C148.495 211.526 147.988 210.528 147.988 209.409Z"
          fill="white"
        />
      </g>
      <path
        d="M159.316 213.371C157.372 213.371 155.787 211.789 155.783 209.843C155.779 207.45 156.703 205.2 158.387 203.507C160.072 201.814 162.312 200.881 164.695 200.881H168.929C173.844 200.881 177.842 204.894 177.842 209.826C177.842 211.782 176.257 213.372 174.308 213.372H159.316V213.371Z"
        fill="#EFEFEF"
      />
      <path
        d="M168.929 201.958C173.259 201.958 176.768 205.48 176.768 209.825C176.768 211.188 175.667 212.294 174.308 212.294H159.316C157.965 212.294 156.859 211.197 156.856 209.84C156.848 205.488 160.361 201.957 164.695 201.957H168.929V201.958ZM168.929 199.804H164.695C162.024 199.804 159.514 200.849 157.628 202.746C155.741 204.642 154.705 207.164 154.71 209.845C154.715 212.383 156.782 214.448 159.316 214.448H174.308C176.848 214.448 178.914 212.374 178.914 209.825C178.914 207.148 177.876 204.631 175.99 202.739C174.104 200.846 171.597 199.804 168.929 199.804Z"
        fill="#404851"
      />
      <g opacity="0.3">
        <g opacity="0.3">
          <path
            opacity="0.3"
            d="M176.768 209.825C176.768 205.48 173.259 201.958 168.929 201.958H164.695C160.361 201.958 156.848 205.489 156.856 209.841C156.859 211.198 157.965 212.295 159.316 212.295H174.308C175.667 212.295 176.768 211.189 176.768 209.825Z"
            fill="#404851"
          />
        </g>
      </g>
      <g opacity="0.8">
        <g opacity="0.8">
          <path
            opacity="0.8"
            d="M214.539 145.569L203.756 145.645C203.755 145.645 203.753 145.644 203.753 145.642L203.745 144.508C203.736 143.208 202.679 142.162 201.384 142.171L185.202 142.284C184.311 142.29 183.517 142.938 183.418 143.827C183.299 144.888 184.126 145.784 185.158 145.776L187.834 145.757L188.235 145.803C188.235 145.803 188.235 145.803 188.236 145.803C189.004 145.98 189.58 146.665 189.586 147.491C189.592 148.316 189.026 149.01 188.261 149.197H188.26L172.165 149.388C171.205 149.396 170.435 150.183 170.442 151.146C170.448 152.112 171.234 152.89 172.197 152.883L173.531 152.873L187.884 152.74L188.286 152.786C189.054 152.963 189.363 153.785 189.368 154.61C189.369 154.703 189.373 154.799 189.379 154.897C189.441 155.791 190.198 156.477 191.092 156.458L200.231 156.267C202.167 156.806 202.572 158.673 202.595 160.04C202.611 160.924 203.281 161.657 204.156 161.754L204.665 161.81C205.337 161.885 205.999 161.57 206.349 160.99C207.017 159.885 207.82 157.965 206.844 156.135C206.842 156.133 206.844 156.13 206.847 156.13L209.046 156.084C210.132 156.076 210.979 155.071 210.729 153.94C210.551 153.133 209.795 152.587 208.971 152.593L201.396 152.646L201.263 152.647C200.231 152.654 199.402 151.758 199.522 150.696C199.623 149.809 200.415 149.162 201.305 149.156L214.617 149.062C215.704 149.054 216.55 148.048 216.3 146.917C216.119 146.109 215.362 145.563 214.539 145.569Z"
            fill="white"
          />
        </g>
        <g opacity="0.8">
          <path
            opacity="0.8"
            d="M180.038 140.977L177.363 140.996C176.254 141.004 175.349 140.108 175.342 138.996C175.334 137.884 176.226 136.976 177.335 136.968L180.01 136.949C181.119 136.942 182.024 137.837 182.031 138.949C182.039 140.062 181.147 140.97 180.038 140.977Z"
            fill="white"
          />
        </g>
      </g>
      <path
        d="M204.362 199.449C203.854 199.449 203.368 199.351 202.916 199.156C200.12 197.952 199.461 193.427 201.416 188.854C202.947 185.272 205.573 182.808 208.055 182.573L219.599 153.181C220.167 151.737 221.381 150.767 222.622 150.767C222.935 150.767 223.238 150.829 223.52 150.951C224.927 151.557 225.431 153.431 224.667 155.217C224.664 155.223 211.652 184.438 211.652 184.438C212.876 186.477 212.795 189.855 211.388 193.148C209.778 196.917 206.954 199.449 204.362 199.449Z"
        fill="#888988"
      />
      <path
        d="M222.623 151.844C222.786 151.844 222.946 151.874 223.098 151.94C223.94 152.302 224.201 153.579 223.682 154.792L210.424 184.558C211.754 186.125 211.81 189.43 210.402 192.723C208.958 196.101 206.442 198.372 204.362 198.372C204.006 198.372 203.662 198.305 203.339 198.166C201.13 197.215 200.71 193.236 202.402 189.278C203.846 185.9 206.361 183.631 208.441 183.631C208.557 183.631 208.672 183.637 208.785 183.652L220.598 153.576C221.007 152.533 221.852 151.844 222.623 151.844ZM222.623 149.69C220.945 149.69 219.329 150.935 218.601 152.786L207.282 181.607C206.077 181.875 204.867 182.552 203.729 183.605C202.391 184.844 201.25 186.512 200.431 188.43C199.471 190.677 199.06 193.038 199.275 195.076C199.392 196.19 199.691 197.175 200.16 198.001C200.723 198.989 201.53 199.731 202.494 200.145C203.08 200.398 203.709 200.525 204.363 200.525C205.943 200.525 207.572 199.789 209.076 198.397C210.414 197.158 211.555 195.49 212.374 193.571C213.172 191.705 213.591 189.774 213.586 187.987C213.581 186.618 213.33 185.401 212.848 184.393L225.641 155.671C225.645 155.66 225.649 155.651 225.653 155.641C226.655 153.299 225.904 150.804 223.944 149.96C223.526 149.781 223.082 149.69 222.623 149.69Z"
        fill="#404851"
      />
      <g opacity="0.4">
        <path
          opacity="0.4"
          d="M203.117 189.996C204.641 186.43 207.36 184.099 209.5 184.37L221.312 154.294C221.801 153.049 222.909 152.312 223.77 152.644C223.628 152.322 223.401 152.071 223.098 151.94C222.231 151.567 221.094 152.311 220.597 153.576L208.784 183.652C206.645 183.381 203.926 185.712 202.402 189.278C200.82 192.977 201.085 196.694 202.93 197.941C201.766 196.3 201.772 193.144 203.117 189.996Z"
          fill="white"
        />
      </g>
      <path
        d="M227.101 197.155H223.403C219.93 197.155 217.105 194.319 217.105 190.834V181.667C217.105 178.182 219.93 175.346 223.403 175.346H227.101C230.574 175.346 233.4 178.182 233.4 181.667V190.834C233.4 194.319 230.574 197.155 227.101 197.155ZM223.403 178.609C221.723 178.609 220.356 179.981 220.356 181.667V190.834C220.356 192.52 221.723 193.892 223.403 193.892H227.101C228.781 193.892 230.148 192.52 230.148 190.834V181.667C230.148 179.981 228.781 178.609 227.101 178.609H223.403V178.609Z"
        fill="#404851"
      />
      <path
        d="M198.771 210.701C191.667 210.701 185.889 204.901 185.889 197.772V170.826C185.889 168.736 187.582 167.036 189.664 167.036H221.275C223.357 167.036 225.051 168.736 225.051 170.826V197.772C225.051 204.901 219.272 210.701 212.169 210.701H198.771Z"
        fill="#C5D3E2"
      />
      <path
        d="M221.276 168.292C222.67 168.292 223.799 169.427 223.799 170.825V197.772C223.799 204.218 218.592 209.444 212.17 209.444H198.771C192.348 209.444 187.142 204.217 187.142 197.772V170.825C187.142 169.426 188.272 168.292 189.665 168.292H221.276V168.292ZM221.276 165.78H189.665C186.893 165.78 184.638 168.044 184.638 170.826V197.772C184.638 199.686 185.012 201.544 185.749 203.295C186.461 204.984 187.48 206.501 188.777 207.803C190.074 209.105 191.586 210.127 193.269 210.842C195.013 211.582 196.864 211.958 198.771 211.958H212.17C214.076 211.958 215.927 211.582 217.672 210.842C219.355 210.127 220.867 209.105 222.164 207.803C223.461 206.501 224.48 204.984 225.192 203.295C225.929 201.545 226.303 199.686 226.303 197.772V170.826C226.303 168.043 224.048 165.78 221.276 165.78Z"
        fill="#404851"
      />
      <g opacity="0.4">
        <path
          opacity="0.4"
          d="M189.287 198.849V171.902C189.287 170.503 190.417 169.369 191.81 169.369H223.338C222.882 168.719 222.129 168.293 221.275 168.293H189.664C188.27 168.293 187.141 169.427 187.141 170.826V197.772C187.141 202.775 190.278 207.04 194.684 208.702C191.44 206.63 189.287 202.993 189.287 198.849Z"
          fill="white"
        />
      </g>
      <g opacity="0.2">
        <path
          opacity="0.2"
          d="M221.275 168.292H214.837C216.231 168.292 217.361 169.426 217.361 170.825V184.719C217.361 194.462 210.245 202.764 200.633 204.137C197.283 204.615 193.281 204.909 188.503 204.909C188.503 204.909 190.471 206.165 190.471 206.524C190.471 206.786 205.326 206.666 213.355 206.581C211.314 208.363 208.649 209.443 205.732 209.443H212.169C218.593 209.443 223.799 204.217 223.799 197.771V170.825C223.799 169.426 222.669 168.292 221.275 168.292Z"
          fill="#404851"
        />
      </g>
      <path
        d="M209.972 181.448V179.734H204.848V181.448H203.14V183.162H202.285H201.431V181.448H199.723V179.734H194.599V181.448H192.891V186.501H194.599V188.215H196.307V189.929H198.015V191.643H199.723V193.357H201.431V195.071H202.285H203.14V193.357H204.848V191.643H206.556V189.929H208.264V188.215H209.972V186.501H211.68V181.448H209.972Z"
        fill="#F75C4C"
      />
      <path
        d="M199.723 178.019H194.599V179.734H199.723V178.019Z"
        fill="#404851"
      />
      <path
        d="M194.599 179.734H192.891V181.448H194.599V179.734Z"
        fill="#404851"
      />
      <path
        d="M194.599 186.501H192.891V188.215H194.599V186.501Z"
        fill="#404851"
      />
      <path
        d="M196.307 188.215H194.599V189.929H196.307V188.215Z"
        fill="#404851"
      />
      <path
        d="M198.015 189.929H196.307V191.643H198.015V189.929Z"
        fill="#404851"
      />
      <path
        d="M199.723 191.643H198.015V193.357H199.723V191.643Z"
        fill="#404851"
      />
      <path
        d="M201.431 193.357H199.723V195.071H201.431V193.357Z"
        fill="#404851"
      />
      <path
        d="M201.431 179.734H199.723V181.448H201.431V179.734Z"
        fill="#404851"
      />
      <path
        d="M192.891 181.448H191.183V186.501H192.891V181.448Z"
        fill="#404851"
      />
      <path
        d="M209.972 178.019H204.848V179.734H209.972V178.019Z"
        fill="#404851"
      />
      <path
        d="M209.972 181.448L211.68 181.448L211.68 179.734L209.972 179.734L209.972 181.448Z"
        fill="#404851"
      />
      <path
        d="M209.972 188.214L211.68 188.214L211.68 186.5L209.972 186.5L209.972 188.214Z"
        fill="#404851"
      />
      <path
        d="M208.264 189.929L209.972 189.929L209.972 188.215L208.264 188.215L208.264 189.929Z"
        fill="#404851"
      />
      <path
        d="M206.556 191.643L208.264 191.643L208.264 189.929L206.556 189.929L206.556 191.643Z"
        fill="#404851"
      />
      <path
        d="M204.847 193.358L206.555 193.358L206.555 191.644L204.847 191.644L204.847 193.358Z"
        fill="#404851"
      />
      <path
        d="M203.139 195.072L204.847 195.072L204.847 193.358L203.139 193.358L203.139 195.072Z"
        fill="#404851"
      />
      <path
        d="M203.139 181.448L204.847 181.448L204.847 179.734L203.139 179.734L203.139 181.448Z"
        fill="#404851"
      />
      <path
        d="M211.68 186.5L213.388 186.5L213.388 181.448L211.68 181.448L211.68 186.5Z"
        fill="#404851"
      />
      <path
        d="M202.241 195.071H201.431V196.786H202.241H202.33H203.14V195.071H202.33H202.241Z"
        fill="#404851"
      />
      <path
        d="M202.33 181.448H202.241H201.431V183.162H202.241H202.33H203.14V181.448H202.33Z"
        fill="#404851"
      />
      <path
        d="M198.015 181.448H196.307H194.599V183.162V184.876H196.307V183.162H198.015V181.448Z"
        fill="white"
      />
      <path
        d="M223.276 213.32H186.733C183.298 213.32 180.512 210.524 180.512 207.076H229.497C229.497 210.524 226.712 213.32 223.276 213.32Z"
        fill="#C6D4E3"
      />
      <path
        d="M223.276 214.576H186.733C182.613 214.576 179.26 211.212 179.26 207.076C179.26 206.382 179.821 205.819 180.512 205.819H229.497C230.189 205.819 230.749 206.382 230.749 207.076C230.748 211.212 227.396 214.576 223.276 214.576ZM181.923 208.332C182.48 210.477 184.425 212.063 186.733 212.063H223.276C225.584 212.063 227.53 210.477 228.086 208.332H181.923Z"
        fill="#404851"
      />
      <g opacity="0.2">
        <path
          opacity="0.2"
          d="M216.758 207.422C216.758 207.422 214.255 212.447 183.539 212.671L185.99 213.217H225.878L229.696 207.615L216.758 207.422Z"
          fill="#404851"
        />
      </g>
      <g opacity="0.2">
        <path
          opacity="0.2"
          d="M224.269 152.145C224.269 152.145 217.831 166.503 213.897 166.503H219.44L224.447 154.478L224.269 152.145Z"
          fill="#404851"
        />
      </g>
      <path
        d="M12.9531 178.048C14.0467 178.048 14.9332 177.158 14.9332 176.06C14.9332 174.963 14.0467 174.073 12.9531 174.073C11.8595 174.073 10.973 174.963 10.973 176.06C10.973 177.158 11.8595 178.048 12.9531 178.048Z"
        fill="#404851"
      />
      <path
        d="M244.237 198.67C245.498 198.67 246.52 197.644 246.52 196.378C246.52 195.113 245.498 194.086 244.237 194.086C242.975 194.086 241.953 195.113 241.953 196.378C241.953 197.644 242.975 198.67 244.237 198.67Z"
        fill="#404851"
      />
      <path
        d="M240.048 117.305C241.101 117.305 241.955 116.448 241.955 115.392C241.955 114.335 241.101 113.479 240.048 113.479C238.996 113.479 238.142 114.335 238.142 115.392C238.142 116.448 238.996 117.305 240.048 117.305Z"
        fill="#404851"
      />
      <path
        d="M232.12 98.5517C232.561 98.1095 232.283 97.0603 231.504 95.8711C231.273 95.5177 231.273 95.0618 231.504 94.7084C232.283 93.5192 232.561 92.4692 232.12 92.0279C231.68 91.5857 230.634 91.8648 229.45 92.6459C229.097 92.8781 228.643 92.8781 228.291 92.6459C227.106 91.8648 226.06 91.5857 225.62 92.0279C225.18 92.4701 225.458 93.5192 226.236 94.7084C226.468 95.0618 226.468 95.5177 226.236 95.8711C225.458 97.0603 225.18 98.1103 225.62 98.5517C226.061 98.9939 227.106 98.7148 228.291 97.9336C228.643 97.7014 229.097 97.7014 229.45 97.9336C230.634 98.7148 231.68 98.9931 232.12 98.5517Z"
        fill="#404851"
      />
      <path
        d="M21.8432 163.477C22.3493 163.477 22.7916 162.713 23.0255 161.579C23.0952 161.242 23.3564 160.98 23.6923 160.91C24.8219 160.675 25.5832 160.232 25.5832 159.723C25.5832 159.215 24.8219 158.771 23.6923 158.536C23.3564 158.466 23.0952 158.204 23.0255 157.867C22.7916 156.734 22.3502 155.969 21.8432 155.969C21.3371 155.969 20.8948 156.734 20.6609 157.867C20.5912 158.204 20.3301 158.466 19.9941 158.536C18.8645 158.771 18.1033 159.214 18.1033 159.723C18.1033 160.231 18.8645 160.675 19.9941 160.91C20.3301 160.98 20.5912 161.242 20.6609 161.579C20.8957 162.713 21.3371 163.477 21.8432 163.477Z"
        fill="#404851"
      />
      <path
        d="M61.8964 63.584C63.5645 63.584 64.9168 62.2269 64.9168 60.5527C64.9168 58.8785 63.5645 57.5214 61.8964 57.5214C60.2283 57.5214 58.8761 58.8785 58.8761 60.5527C58.8761 62.2269 60.2283 63.584 61.8964 63.584Z"
        fill="#404851"
      />
      <path
        d="M47.0447 77.8316C48.135 77.8316 49.0189 76.9445 49.0189 75.8502C49.0189 74.756 48.135 73.8689 47.0447 73.8689C45.9544 73.8689 45.0706 74.756 45.0706 75.8502C45.0706 76.9445 45.9544 77.8316 47.0447 77.8316Z"
        fill="#404851"
      />
    </BaseIcon>
  );
};

export default ComputerHelloIcon;
